var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTherapyDis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-autism",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-autism:not(.animated) .animable {opacity: 0;}svg#freepik_stories-autism.animated #freepik--speech-bubble-2--inject-2 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-autism.animated #freepik--speech-bubble-1--inject-2 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    className: "animable",
    style: {
      transformOrigin: "379.76px 256.48px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103,358.45a41.78,41.78,0,0,1,11.11-27.6C117.48,344.7,103,358.45,103,358.45Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "108.809px 344.65px"
    },
    id: "elmoyvlpf8bes",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.14,350.64a41.75,41.75,0,0,1,29.74-.82C137.53,358.42,119.14,350.64,119.14,350.64Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "134.01px 350.671px"
    },
    id: "elo647mctc31",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,341.66a32.91,32.91,0,0,1,4-23.11C129.89,328.69,121,341.66,121,341.66Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "123.429px 330.105px"
    },
    id: "elqcwn6l15gnc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,309.29c23.58,6.28,36.23,26.78,36.23,26.78C74.68,336.08,58.6,309.29,58.6,309.29Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "76.715px 322.68px"
    },
    id: "el1t7aj3lz2y9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.26,319c-1.22-25.41,23.62-54.18,23.62-54.18C116.13,296.33,96.26,319,96.26,319",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "108.048px 291.91px"
    },
    id: "elvmn596kgvof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.14,246.57A68,68,0,0,1,87.21,283C83.7,266.63,96.14,246.57,96.14,246.57Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "91.3888px 264.785px"
    },
    id: "elgi3v55tnxcm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.56,298.21c-18.58-2-28.68-20.48-28.68-20.48C80.35,284,86.56,298.21,86.56,298.21Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "72.22px 287.97px"
    },
    id: "elzp14ujt51d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.49,375.91a41.75,41.75,0,0,1,29.21-5.63C65.89,380.61,46.49,375.91,46.49,375.91Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "61.095px 373.314px"
    },
    id: "elmc133a6pqdc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.64,384.25c-3.53,9.71-12.49,14.06-12.49,14.06C82.94,389.74,94.64,384.25,94.64,384.25Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "88.395px 391.28px"
    },
    id: "el8pkt1fuhw82",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.25,381.51c-10.57,6.51-22.23,4-22.23,4C77.18,378,92.25,381.51,92.25,381.51Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "81.135px 383.338px"
    },
    id: "ela9708vh405v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.75,415.72s0-.13,0-.38,0-.66,0-1.1c0-1.05,0-2.47,0-4.26s0-4.11,0-6.74,0-5.61-.19-8.92c-.16-6.6-.63-14.46-1.3-23.17s-1.81-18.25-3.27-28.23c-2.94-20-6.95-37.8-10.17-50.61-1.63-6.41-3-11.58-4-15.14l-1.11-4.12c-.11-.43-.19-.78-.27-1.07a1.67,1.67,0,0,1-.06-.38,2.19,2.19,0,0,1,.15.35l.34,1.06c.31,1,.73,2.35,1.26,4.07,1.1,3.53,2.56,8.68,4.26,15.08A473,473,0,0,1,97.71,342.8c1.45,10,2.49,19.56,3.2,28.29s1,16.6,1.13,23.22c.1,3.31.07,6.3.07,8.93s0,4.89-.11,6.74-.11,3.22-.15,4.26c0,.44,0,.81,0,1.11A1.49,1.49,0,0,1,101.75,415.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "91.7471px 343.66px"
    },
    id: "elmbh08qc2q8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.64,361.93c.13-.19,7.64,4.73,16.78,11s16.43,11.49,16.3,11.68-7.64-4.73-16.78-11S67.51,362.12,67.64,361.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "84.18px 373.27px"
    },
    id: "elt9b826na05",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.72,364.63a7,7,0,0,1,1.15-1.26l3.35-3.22,11.16-10.47,11.17-10.48,3.39-3.17a6.63,6.63,0,0,1,1.31-1.09,6.47,6.47,0,0,1-1.08,1.32c-.73.82-1.83,2-3.2,3.37-2.75,2.8-6.64,6.57-11,10.66s-8.39,7.71-11.34,10.3c-1.47,1.29-2.67,2.32-3.52,3A6.09,6.09,0,0,1,100.72,364.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "116.485px 349.785px"
    },
    id: "ellttgtit8sxh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.79,349.88s19.2-.36,27.32,14.75A34.57,34.57,0,0,1,43.79,349.88Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "57.45px 357.255px"
    },
    id: "el2lbtag4jhi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,342.18s15.64,11.15,13.15,28.13A34.62,34.62,0,0,1,70,342.18Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "76.7026px 356.245px"
    },
    id: "elrtcqrmjxa5d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.37,314.69s-6.17,21.5-25.78,25.36A40.31,40.31,0,0,1,152.37,314.69Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "139.48px 327.37px"
    },
    id: "elg6df76mn2t8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.48,234.78s24.5,16,21.79,42C83.27,276.76,62.18,263.41,61.48,234.78Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "72.4797px 255.78px"
    },
    id: "el0az0doqb3jb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,376.93a9.6,9.6,0,0,1-1.59,1.27c-1.06.77-2.57,1.91-4.39,3.36A110.89,110.89,0,0,0,123.77,394a109.75,109.75,0,0,0-11,14.53c-1.25,2-2.22,3.59-2.87,4.72a9.18,9.18,0,0,1-1.1,1.72,9.88,9.88,0,0,1,.81-1.87c.56-1.18,1.46-2.86,2.65-4.88a94.89,94.89,0,0,1,10.86-14.78,93.11,93.11,0,0,1,13.53-12.37c1.88-1.4,3.45-2.48,4.57-3.16A9.18,9.18,0,0,1,143,376.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "125.9px 395.95px"
    },
    id: "el0vpr93gkv2ab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.7,392.89a41.78,41.78,0,0,1,5.63-29.21C130,381.89,121.7,392.89,121.7,392.89Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "124.466px 378.285px"
    },
    id: "elvdfop6tgumg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.19,383.9a30.34,30.34,0,0,1,21.38-3.31C147.74,386.86,138.19,383.9,138.19,383.9Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "148.88px 382.258px"
    },
    id: "elctacku3taxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.03 417.72 75.22 478.13 128.62 478.13 141.01 418.59 66.03 417.72",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "103.52px 447.925px"
    },
    id: "el4o1254mxhmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.55,456.43c0,.18-13.69.32-30.56.32s-30.57-.14-30.57-.32,13.69-.31,30.57-.31S133.55,456.26,133.55,456.43Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "102.985px 456.435px"
    },
    id: "el6j8epooubo8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.75,453.46c0,.18-13.77.32-30.76.32s-30.77-.14-30.77-.32,13.77-.31,30.77-.31S133.75,453.29,133.75,453.46Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "102.985px 453.465px"
    },
    id: "el7zwthppmluf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65,450.11c0,.17-13.78.31-30.77.31s-30.77-.14-30.77-.31,13.78-.32,30.77-.32S133.65,449.93,133.65,450.11Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "102.88px 450.105px"
    },
    id: "elw1fqsxvksws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.35,474.68c-.17,0-.9-3.38-1.64-7.61s-1.19-7.68-1-7.71.91,3.38,1.64,7.61S81.52,474.65,81.35,474.68Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "80.0265px 467.02px"
    },
    id: "elokuli2x65rc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,474c-.17,0-.38-3.33-.66-7.42s-.52-7.43-.35-7.45.7,3.29,1,7.4S85.15,474,85,474Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "84.5502px 466.565px"
    },
    id: "eleec9wodnzj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,474c-.16,0-.89-3.36-1.38-7.6s-.58-7.72-.41-7.73.53,3.43,1,7.65S91.78,474,91.6,474Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "90.6843px 466.335px"
    },
    id: "elq16lzvteam",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.25,474.35a38.78,38.78,0,0,1-.74-7.73c-.14-4.29.07-7.76.24-7.76s.25,3.47.39,7.74S96.43,474.34,96.25,474.35Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "95.8984px 466.605px"
    },
    id: "elk5g82ojv1mk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.48,474c-.17,0-.42-3.28-.56-7.34s-.11-7.35.06-7.36.43,3.28.57,7.34S104.65,474,104.48,474Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "104.233px 466.65px"
    },
    id: "el7re9ehglik7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.49,474.36c-.17,0-.29-3.4-.25-7.6s.2-7.58.37-7.58.29,3.4.26,7.59S110.66,474.36,110.49,474.36Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "110.553px 466.77px"
    },
    id: "el2bsi7nwea5t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.12,473.55c-.17,0,0-3.57.46-7.93s.91-7.89,1.08-7.88,0,3.57-.46,7.94S116.3,473.57,116.12,473.55Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "116.89px 465.645px"
    },
    id: "els0zn1mfe4bm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.39,472.76c-.17,0,.09-3.07.9-6.75a27.71,27.71,0,0,1,2-6.51c.18.05-.58,3-1.37,6.64S123.57,472.78,123.39,472.76Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "124.829px 466.13px"
    },
    id: "el5s1jwgk11a5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9,405.76v11.3a4.45,4.45,0,0,0,4.45,4.45h77.33a4.45,4.45,0,0,0,4.45-4.45v-11.3Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "103.015px 413.635px"
    },
    id: "elxa34a2co13",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.6 421.51 67.24 425.11 138.6 430.2 140.41 421.51 66.6 421.51",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "103.505px 425.855px"
    },
    id: "eldfwr9jue5kc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.92,468.55c-1.81-1.55-5.85-6.47-2.73-12.19,1.14-2.09,3.56-3.13,5.75-4.05s4.5-1.73,6.32-3.28c3.42-2.91,4.37-7.75,6.64-11.63,2.61-4.46,7.48-7.8,12.62-7.57,5.89.27,10.8,5.08,13,10.57s2.3,11.57,2.35,17.5c0,3.27-.12,7-2.52,9.18-2.22,2-5.56,2.06-8.57,2l-32.19-1",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "359.957px 449.456px"
    },
    id: "elnj9tp5nfu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.49,380H316.83L332.08,471a10.15,10.15,0,0,0,7.23,8.09l.29.09c.26.06.5.14.76.19a10.78,10.78,0,0,0,1.72.2v.08l.42-.06h37.73a10.83,10.83,0,0,0,10.64-9.09l7.35-62.66.33-2.49h0l2.91-24.81Zm-16,58h-8.69l.88-26.39h10.06Zm3.1-26.39h8.31L393.84,438h-7.48ZM363.8,467.29l-.53-22.93h12.51L375,467.29Zm-13.53-22.93h12.16l.52,22.93h-10.9Zm.94,22.93H341c-1-6.19-2.23-14.24-3.6-22.93h12ZM349.78,438l-2-26.39h13.94l.61,26.39Zm13.34,0-.61-26.39h14.36L376,438Zm-.75-32.72-.57-24.44h16.09l-.81,24.44Zm-.84,0h-14.3l-1.89-24.44H361Zm-15.14,0H331.27c-.53-3.38-1-6.57-1.5-9.45-1.58-9.88-2.17-13.59-2.5-15h17.22Zm.49,6.33L348.94,438H336.43c-.42-2.68-.85-5.39-1.27-8.1-1-6.23-2-12.46-2.89-18.29ZM335.58,438h-8.17L323,411.64h8.44C332.71,419.79,334.14,428.87,335.58,438Zm1,6.33c1.25,7.93,2.47,15.75,3.6,22.93h-7.85l-3.85-22.93Zm39.29,22.93.76-22.93H385l-2,22.93Zm2.06-62,.81-24.44H390.4l-2.09,24.44Zm-51.45-24.44c.33,1.77,1.88,11.38,3.95,24.44h-8.5l-4.1-24.44Zm63.93,86.42h-6.54l2-22.93h7.28Zm7.28-62h-8.52l2.09-24.44h9.29Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "359.16px 429.825px"
    },
    id: "el19gq1lmf91o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.95 45.73 423.53 45.73 423.53 174.17 335.56 174.17 334.95 45.73",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "379.24px 109.95px"
    },
    id: "el5dhd4jg54s8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcufhn0kg9qc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.31,
    y: 46.34,
    width: 87.78,
    height: 127.23,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "372.2px 109.955px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el58b70040vs9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.69,45.73V174.17h-89V45.73ZM415.48,173v-126H328.91V173Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "372.19px 109.95px"
    },
    id: "elrlndl8ung2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.21,
    y: 60.12,
    width: 65.96,
    height: 99.67,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "372.19px 109.955px"
    },
    id: "ely2y2qxecn4q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.21,60.12s0,.17,0,.49,0,.81,0,1.42c0,1.26,0,3.09,0,5.47,0,4.79.05,11.75.08,20.54,0,17.57.08,42.45.14,71.74l-.29-.28,66,0h0l-.32.31c0-37.59.05-72.26.07-99.66l.25.25-48-.13-13.27-.07-3.49,0c-.79,0-1.21,0-1.21,0l1.16,0,3.44,0L357,60l48.15-.13h.25v.25c0,27.4,0,62.07.06,99.66v.32h-.32l-66,0h-.29v-.29c.06-29.36.11-54.31.15-71.93,0-8.76.06-15.7.07-20.47,0-2.36,0-4.17,0-5.42,0-.6,0-1.06,0-1.38S339.21,60.12,339.21,60.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "372.155px 109.985px"
    },
    id: "elyvqopoyuyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,173.56a10.88,10.88,0,0,1,1.42-2.18c.94-1.3,2.27-3.08,3.8-5s3-3.6,4.07-4.78a10.68,10.68,0,0,1,1.86-1.83c.14.12-2.39,3.18-5.44,7S328.2,173.68,328.06,173.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "333.638px 166.667px"
    },
    id: "elxsc8cqha5pr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.31,46.34c.13-.11,2.69,2.89,5.7,6.69s5.34,7,5.2,7.09a64.41,64.41,0,0,1-5.7-6.7C330.5,49.62,328.17,46.45,328.31,46.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "333.76px 53.2285px"
    },
    id: "elwbywsk3nts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.1,46.44,404.6,60.62",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "410.35px 53.53px"
    },
    id: "el6lj9np57twq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.6,60.62c-.14-.11,2.33-3.37,5.5-7.29s5.86-7,6-6.89-2.33,3.37-5.51,7.29S404.73,60.73,404.6,60.62Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.35px 53.53px"
    },
    id: "el3tqeowglx12",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.08,173.56c-.13.11-2.66-2.85-5.64-6.62s-5.28-6.91-5.14-7,2.66,2.85,5.64,6.62S416.22,173.46,416.08,173.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.69px 166.75px"
    },
    id: "ellfccfgih9tf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.13,90s1.43-2.69,5.79-2.69a6.3,6.3,0,0,1,5.85,3.38s4.21,9,3.1,13.45c-5-6.38-2.81-8.93-9.14-8.92s-9.05,9-9.05,9S363.69,97.93,368.13,90Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "373.821px 95.7622px"
    },
    id: "elw90rdl59ln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.13,90s1.43-2.69,5.79-2.69a6.3,6.3,0,0,1,5.85,3.38s4.21,9,3.1,13.45c-5-6.38-2.81-8.93-9.14-8.92s-9.05,9-9.05,9S363.69,97.93,368.13,90Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "373.821px 95.7622px"
    },
    id: "el3cyl3fgq6e9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.55,126l-5,1.85-.81,6.68s-14.9-20.52-16.82-23.93-3.39-3.72-3.4-9.09S368.13,90,368.13,90s-2,3.73-.51,7.1S390.55,126,390.55,126Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "377.535px 112.265px"
    },
    id: "elg0alw01xant",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.55,126l-5,1.85-.81,6.68s-6-8.32-10.93-15.25c2.1-3,4-5.72,5.07-7.41C384.68,119,390.55,126,390.55,126Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "382.18px 123.2px"
    },
    id: "el5iznx68wo2e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.11,128.09l5,1.83.85,6.67s14.81-20.57,16.73-24,3.37-3.74,3.36-9.1S379.4,92,379.4,92s2,3.72.53,7.09S357.11,128.09,357.11,128.09Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "370.08px 114.295px"
    },
    id: "eln029e72skqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.11,128.09l5,1.83.85,6.67s6-8.34,10.86-15.28c-2.1-3-4-5.7-5.09-7.39C363,121.09,357.11,128.09,357.11,128.09Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "365.465px 125.255px"
    },
    id: "el19nugg231zz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.78,105.49h0c-1.58,2-3.32,4.19-5.07,6.36-.36-.55-.63-1-.8-1.29-1.93-3.41-3.39-3.72-3.4-9.09S368,90.18,368.13,90c-.09.16-1.93,3.8-.51,7.09C368.09,98.13,370.59,101.46,373.78,105.49Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "369.145px 100.925px"
    },
    id: "el392ev9akm8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj0jfqbibjt"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.29,
    y: 38.19,
    width: 80.63,
    height: 59.48,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.605px 67.93px",
      transform: "rotate(-7.24deg)"
    },
    className: "animable",
    id: "elpid9it20mzp"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.34,92.35s-.06-.37-.15-1.08-.23-1.77-.42-3.13c-.35-2.75-.87-6.78-1.54-11.92-1.32-10.27-3.22-25-5.51-42.86l.14.11-80,10.19h0l.14-.18c2.68,21.19,5.23,41.26,7.48,59l-.16-.12,57.71-7.26,16.42-2,4.36-.54,1.12-.13.39,0-.37.05-1.11.15-4.32.57-16.37,2.12-57.8,7.41-.14,0,0-.15c-2.25-17.74-4.81-37.81-7.5-59l0-.15.15,0h0l80-10.12.13,0v.13c2.25,17.89,4.1,32.66,5.39,43,.64,5.13,1.14,9.15,1.48,11.89.16,1.36.29,2.4.38,3.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "188.525px 68.02px"
    },
    id: "elifuzecvym5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.45,
    y: 37.29,
    width: 5.11,
    height: 12.68,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "152.005px 43.63px"
    },
    id: "ely3ooc2kgrzo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzxvuthxeq8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.18,
    y: 83.06,
    width: 5.11,
    height: 12.68,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "227.735px 89.4px",
      transform: "rotate(48.89deg)"
    },
    className: "animable",
    id: "el2cpzxw7u5y5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.58,60.3a1.44,1.44,0,0,1,.24.23,5,5,0,0,1,.59.73,6.64,6.64,0,0,1,1.1,3.28,6,6,0,0,1-.31,2.39,5.88,5.88,0,0,1-1.52,2.32A6,6,0,0,1,166,70.72a5.07,5.07,0,0,1-3.27-.26,5.28,5.28,0,0,1-3.26-5.11,5.43,5.43,0,0,1,2.76-4.22,5.94,5.94,0,0,1,3.38-.71,5.42,5.42,0,0,1,.93.16,1.19,1.19,0,0,1,.31.11s-.44-.11-1.25-.15a6.12,6.12,0,0,0-3.26.78,5.22,5.22,0,0,0-2.57,4.05,5,5,0,0,0,3.08,4.8,4.82,4.82,0,0,0,3.08.25A5.81,5.81,0,0,0,168.48,69a5.64,5.64,0,0,0,1.81-4.48,6.65,6.65,0,0,0-1-3.22C168.88,60.64,168.55,60.32,168.58,60.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "164.996px 65.5889px"
    },
    id: "elh1u0qz5865",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,59.52a42.44,42.44,0,0,1-4.67,2.12,42.54,42.54,0,0,1-4.78,1.83,41.71,41.71,0,0,1,4.66-2.12A41.44,41.44,0,0,1,164,59.52Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "159.275px 61.495px"
    },
    id: "el4r921xpss5h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.14,60.48a9.45,9.45,0,0,1-1.31.92c-.84.53-2,1.25-3.29,2s-2.46,1.47-3.32,2a7.88,7.88,0,0,1-1.43.73,7.73,7.73,0,0,1,1.31-.91c.83-.54,2-1.26,3.28-2s2.47-1.46,3.33-1.95A8.17,8.17,0,0,1,163.14,60.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "158.465px 63.305px"
    },
    id: "el9x283m5j7vf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.86,63.86a4.84,4.84,0,0,1,.1-1.74,4.74,4.74,0,0,1,.42-1.69,5,5,0,0,1-.11,1.74A4.78,4.78,0,0,1,163.86,63.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "164.117px 62.145px"
    },
    id: "el4tpvg07qwc3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.22,63.68a3.58,3.58,0,0,1-.05-1.5,3.58,3.58,0,0,1,.27-1.48,3.6,3.6,0,0,1,.05,1.5A3.53,3.53,0,0,1,165.22,63.68Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "165.33px 62.19px"
    },
    id: "elhlye39lx87d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.37,63.49a3.88,3.88,0,0,1-.14-1.55,3.81,3.81,0,0,1,.18-1.54,3.82,3.82,0,0,1,.14,1.54A4.3,4.3,0,0,1,166.37,63.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "166.39px 61.945px"
    },
    id: "elbgcfjq2kgcs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,63.62a3.76,3.76,0,0,1-.36-1.5,3.75,3.75,0,0,1,0-1.54,4.07,4.07,0,0,1,.35,1.5A3.67,3.67,0,0,1,168,63.62Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "167.818px 62.1px"
    },
    id: "elsc6deg02hpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,68.7a9.87,9.87,0,0,1-.9-1.26c-.54-.79-1.3-1.86-2.2-3s-1.79-2.11-2.44-2.81a8.5,8.5,0,0,1-1-1.15,7,7,0,0,1,1.19,1,29,29,0,0,1,4.67,5.83A6,6,0,0,1,175,68.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "171.73px 64.59px"
    },
    id: "elh0pdl1rwtfg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.48,66.55a40.37,40.37,0,0,1-4.19-2.89,40.75,40.75,0,0,1-4-3.14,40.37,40.37,0,0,1,4.19,2.89A40.75,40.75,0,0,1,177.48,66.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "173.385px 63.535px"
    },
    id: "elkg5e9zx7i9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.09,66.8s0,.36-.38.78a2.24,2.24,0,0,1-3.66-.33c-.28-.47-.27-.83-.23-.83s.12.31.41.71a2.34,2.34,0,0,0,1.59.92,2.3,2.3,0,0,0,1.73-.63C166.92,67.08,167,66.78,167.09,66.8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "164.945px 67.3995px"
    },
    id: "eli1im3k504n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.73,64.44c0,.09,0,.19-.11.3s-.13.22-.22.24-.18-.19-.05-.4S162.71,64.36,162.73,64.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "162.507px 64.6875px"
    },
    id: "elw48qay5f5on",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.57,64.44c.09,0,.15.16.13.34s-.09.32-.18.31-.14-.16-.13-.34S166.48,64.43,166.57,64.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "166.546px 64.765px"
    },
    id: "elah6xl82svoq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.38,70.21l.14.22.36.67,1.33,2.54c1.13,2.22,2.69,5.28,4.51,8.83l.09.19-.21,0-6.07.72-4,.46-.95.11a2.74,2.74,0,0,1-1,0,1,1,0,0,1-.49-.24.89.89,0,0,1-.23-.5,2.4,2.4,0,0,1,.16-1c.68-2.27,1.3-4.32,1.83-6.06l1.26-4.08c.15-.45.26-.82.36-1.1a2,2,0,0,1,.14-.38,2.38,2.38,0,0,1-.08.4c-.08.29-.18.66-.3,1.12-.29,1-.68,2.4-1.17,4.11s-1.1,3.8-1.76,6.08a2.07,2.07,0,0,0-.15.82.56.56,0,0,0,.49.49,2.69,2.69,0,0,0,.89,0l1-.11,4-.47,6.07-.71-.12.22C170.68,79,169.15,76,168,73.73l-1.25-2.58c-.13-.28-.23-.51-.32-.69A.84.84,0,0,1,166.38,70.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "166.333px 77.103px"
    },
    id: "el3pdgapb4wlr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51,89.4a13.91,13.91,0,0,1,0-2.85,12.73,12.73,0,0,1,.27-2.85,12.87,12.87,0,0,1,0,2.86A12.92,12.92,0,0,1,164.51,89.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "164.648px 86.55px"
    },
    id: "elm69t7uqrvo7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,88.78a2.34,2.34,0,0,0-1-.2,2.28,2.28,0,0,1-1.15-.23,1,1,0,0,1-.44-.63,3.15,3.15,0,0,1,0-.75,19.32,19.32,0,0,1,.36-3.52,19.51,19.51,0,0,1,0,3.54,3,3,0,0,0,0,.67.6.6,0,0,0,.29.44,2.33,2.33,0,0,0,1,.26,2.11,2.11,0,0,1,.76.21C171.09,88.67,171.15,88.77,171.13,88.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "169.826px 86.115px"
    },
    id: "el5hfepmorau8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.62,74.66a24.76,24.76,0,0,1-3.56-1.74,23.38,23.38,0,0,1-3.4-2,24.78,24.78,0,0,1,3.55,1.73A25.18,25.18,0,0,1,173.62,74.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "170.14px 72.79px"
    },
    id: "el8nq25skujbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.34,70.7A28.36,28.36,0,0,1,160.51,74,30.52,30.52,0,0,1,157.45,77a28.36,28.36,0,0,1,2.83-3.28A30.52,30.52,0,0,1,163.34,70.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "160.395px 73.85px"
    },
    id: "elntejtxbit2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,68.09a1.81,1.81,0,0,1,.32,0,5,5,0,0,1,.85.29,5.22,5.22,0,0,1,2.39,2.28,4.73,4.73,0,0,1,.56,2.24,5.11,5.11,0,0,1-.71,2.56,5,5,0,0,1-2.13,2,5.09,5.09,0,0,1-3.12.41A5.19,5.19,0,0,1,178,76.46,5.21,5.21,0,0,1,177,71.18a4.6,4.6,0,0,1,1.3-1.91,5.24,5.24,0,0,1,3-1.3,4.87,4.87,0,0,1,.9,0,1.49,1.49,0,0,1,.31.07s-.43-.06-1.2,0a5.17,5.17,0,0,0-2.89,1.35,4.55,4.55,0,0,0-1.21,1.83,5,5,0,0,0-.18,2.51,4.71,4.71,0,0,0,1.23,2.47,4.83,4.83,0,0,0,8.26-3.31,4.48,4.48,0,0,0-.5-2.14,5.21,5.21,0,0,0-2.24-2.27C183.1,68.19,182.67,68.13,182.67,68.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "181.733px 72.9524px"
    },
    id: "elfu80w0ra1me",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.75,72.54c-.07,0-.26-.08-.3-.34s.09-.45.17-.42.11.19.14.36S179.82,72.48,179.75,72.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "179.618px 72.1584px"
    },
    id: "el7e2zq5vk0fm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.23,72.33c0,.07-.32-.08-.39-.42s.12-.58.19-.53.07.24.12.47S183.29,72.26,183.23,72.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "183.037px 71.8601px"
    },
    id: "elhcxbpymcdwu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.41,72.88a1.47,1.47,0,0,1-.37.74,3.35,3.35,0,0,1-3.61,1.18c-.5-.15-.75-.35-.73-.38s.3.08.78.16a3.84,3.84,0,0,0,1.84-.11,3.78,3.78,0,0,0,1.55-1C184.21,73.12,184.36,72.86,184.41,72.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "182.054px 73.9079px"
    },
    id: "elt70t0cemo1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.51,77a7.73,7.73,0,0,1-2.69-.25,8,8,0,0,1-2.57-.85,19.86,19.86,0,0,1,2.63.55A21.46,21.46,0,0,1,179.51,77Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "176.88px 76.4633px"
    },
    id: "elcvuztq48zql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,65.86a5.19,5.19,0,0,1,.11,3.09,5,5,0,0,1-.14-1.55A4.9,4.9,0,0,1,179.26,65.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "179.368px 67.405px"
    },
    id: "el3iarxb6s368",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.71,66.14a3.42,3.42,0,0,1,.19,1.4,3.21,3.21,0,0,1-.12,1.41,3.38,3.38,0,0,1-.19-1.4A3.21,3.21,0,0,1,180.71,66.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "180.745px 67.545px"
    },
    id: "elh77e5kh15ae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.32,64.84a9.32,9.32,0,0,1-.51,1.64,9.09,9.09,0,0,1-.5,1.65,3.31,3.31,0,0,1,.2-1.74A3.26,3.26,0,0,1,183.32,64.84Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "182.796px 66.485px"
    },
    id: "elsifaaa5w2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,75.92a2.24,2.24,0,0,1,.22.55c.13.36.29.89.49,1.54s.44,1.44.69,2.28a1.7,1.7,0,0,1,.11.74.61.61,0,0,1-.21.4.85.85,0,0,1-.4.18c-.52,0-1,.07-1.53.11l-2.91.18-.66,0a1.4,1.4,0,0,1-.35,0,.44.44,0,0,1-.3-.31,2.47,2.47,0,0,1,0-.61l0-.54c0-.67.09-1.22.12-1.6a2.46,2.46,0,0,1,.09-.59,2.48,2.48,0,0,1,0,.6c0,.38,0,.93,0,1.6,0,.18,0,.35,0,.54a2.3,2.3,0,0,0,0,.53c0,.14.14.14.37.11l.66,0,2.91-.2c.51,0,1-.06,1.49-.11.22,0,.35-.13.37-.32a1.53,1.53,0,0,0-.09-.61c-.23-.84-.44-1.62-.62-2.3s-.31-1.19-.4-1.56A2.44,2.44,0,0,1,186,75.92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "184.323px 78.9155px"
    },
    id: "elwvvh67n3ikq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.1,83.45a5.46,5.46,0,0,1,0,1.4V85H184l-1.76-.11-.54,0h-.16v-.15a13.6,13.6,0,0,1,.33-2.59,11.79,11.79,0,0,1,0,2.61l-.14-.17.55,0,1.75.16-.14.12A4.66,4.66,0,0,1,184.1,83.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "182.843px 83.575px"
    },
    id: "elajoe2gbe3yr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.48,81.37a3.33,3.33,0,0,1,.36,1c.1.36.2.74.31,1.13a2.3,2.3,0,0,1,.1.73,1,1,0,0,1-.46.71,2.1,2.1,0,0,1-1.49.16h-.1l0-.09c-.15-.6-.27-1.11-.35-1.48l.09.07a2.66,2.66,0,0,1-.74-.07s.27-.08.74-.12H185l0,.08c.12.36.28.86.45,1.45l-.12-.11a1.91,1.91,0,0,0,1.27-.13.66.66,0,0,0,.33-.49,2.38,2.38,0,0,0-.07-.63q-.13-.59-.24-1.14A4,4,0,0,1,186.48,81.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "185.725px 83.2697px"
    },
    id: "el5gq92hvrbkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.87,87.81s.16-.14.49-.18a1.71,1.71,0,0,1,1.27.42l-.25.1q0-.42.06-.87a12,12,0,0,1,.37-2.62,10.7,10.7,0,0,1-.05,2.65c0,.3,0,.58-.08.86l0,.32-.22-.22a1.64,1.64,0,0,0-1.06-.45C181.07,87.8,180.89,87.85,180.87,87.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "181.87px 86.575px"
    },
    id: "elauoavx3enzc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,87.49a7.14,7.14,0,0,1-1.94.44l-.15,0,0-.15-.1-.49a9.92,9.92,0,0,1-.34-2.48,10.17,10.17,0,0,1,.65,2.41l.1.5-.18-.12A7.23,7.23,0,0,1,189,87.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "187.735px 86.37px"
    },
    id: "el9vnji6pj8u6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.4,73.06a19,19,0,0,1-2.87,1.8,17.86,17.86,0,0,1-3,1.53,19,19,0,0,1,2.87-1.8A17.86,17.86,0,0,1,191.4,73.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "188.465px 74.725px"
    },
    id: "el0f20tcxev0hd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.77,52.65a1.54,1.54,0,0,1,.37-.08,5.88,5.88,0,0,1,1.09,0A6.7,6.7,0,0,1,201,53.93a6.83,6.83,0,0,1,2.59,5.23,4.91,4.91,0,0,1-.3,1.72,3.54,3.54,0,0,1-1.08,1.49,6.51,6.51,0,0,1-1.65.92c-.58.23-1.18.46-1.8.64a6.19,6.19,0,0,1-3.78.09,4.71,4.71,0,0,1-2.6-2.37,5.53,5.53,0,0,1-.53-3.15,7.44,7.44,0,0,1,.84-2.65A6,6,0,0,1,195.41,53a2.52,2.52,0,0,1,1.07-.22,1.65,1.65,0,0,1,.38.05,3.43,3.43,0,0,0-1.4.28A6,6,0,0,0,192.84,56a7,7,0,0,0-.78,2.57,5.32,5.32,0,0,0,.53,3A4.43,4.43,0,0,0,195,63.73a6,6,0,0,0,3.59-.1c.61-.18,1.2-.4,1.77-.63a6.28,6.28,0,0,0,1.57-.87,3.68,3.68,0,0,0,1.29-3,6.64,6.64,0,0,0-2.43-5,6.84,6.84,0,0,0-3.6-1.45A12.37,12.37,0,0,0,195.77,52.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "197.698px 58.4086px"
    },
    id: "elncsg6ml789f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.36,57.74c-.08,0-.07-.27,0-.55s.23-.48.32-.45.07.27,0,.55S195.45,57.77,195.36,57.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "195.522px 57.24px"
    },
    id: "elijjr7eh0jv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,57c-.08,0-.24-.13-.37-.37s-.16-.48-.09-.52.25.12.37.37S199.08,57,199,57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "198.771px 56.5519px"
    },
    id: "eltkinmoe1ex",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.91,57.71a1.89,1.89,0,0,1-.4,1,3.77,3.77,0,0,1-4.53,1.4,1.9,1.9,0,0,1-.87-.56s.36.17.95.35a3.91,3.91,0,0,0,4.27-1.32C200.72,58.06,200.86,57.69,200.91,57.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "198.01px 59.0443px"
    },
    id: "eldifl9s7epz9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.08,55.7c-.07,0-.3-.37-.36-.93s.08-1,.16-1,.1.44.16,1S195.17,55.67,195.08,55.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "194.914px 54.735px"
    },
    id: "elzaqiq8znfng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.56,55.38c-.07,0-.38-.39-.55-1s-.14-1.16,0-1.16.19.49.35,1.08S196.64,55.34,196.56,55.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "196.239px 54.3px"
    },
    id: "elwqvjvyebupg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.3,55.25c0,.08-.57-.14-1-.69s-.51-1.12-.42-1.13.28.45.67.94S198.35,55.17,198.3,55.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "197.576px 54.3479px"
    },
    id: "elyx4sdcuv6v8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.86,64.86a1,1,0,0,1,.37-.62,3.74,3.74,0,0,1,.69-.48,3.26,3.26,0,0,0,.86-.63.87.87,0,0,0,.17-1.08c-.22-.37-.73-.58-1.07-1.08a1.12,1.12,0,0,1-.13-.91,1.73,1.73,0,0,1,.5-.8,4,4,0,0,1,1.7-.76,2.48,2.48,0,0,0,1.43-.88,1,1,0,0,0,.18-.71,4.23,4.23,0,0,0-.24-.77,2,2,0,0,1,.17-1.58,2.92,2.92,0,0,1,.93-1,5.27,5.27,0,0,1,1.83-.7,2.82,2.82,0,0,1,.7-.1,3.52,3.52,0,0,1-.67.22,5.83,5.83,0,0,0-1.73.77,2.59,2.59,0,0,0-.82,1,1.75,1.75,0,0,0-.13,1.37,5,5,0,0,1,.26.82,1.35,1.35,0,0,1-.22.93,2.77,2.77,0,0,1-1.6,1,3.94,3.94,0,0,0-1.58.69,1.07,1.07,0,0,0-.33,1.33c.25.41.76.64,1.05,1.1a1,1,0,0,1,.11.76,1.33,1.33,0,0,1-.35.6,3.25,3.25,0,0,1-.93.63,4.11,4.11,0,0,0-.7.43A2.13,2.13,0,0,0,186.86,64.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "190.905px 58.81px"
    },
    id: "elatz845xu44l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,58.4a2.25,2.25,0,0,1,.34-.47,3.5,3.5,0,0,0,.7-1.36,1.68,1.68,0,0,0-.11-1,1.07,1.07,0,0,0-.87-.62,11,11,0,0,0-1.37,0,1.64,1.64,0,0,1-.79-.17,1.15,1.15,0,0,1-.53-.67,9.26,9.26,0,0,1-.09-1.52,1.09,1.09,0,0,0-.67-1,2.25,2.25,0,0,0-1.17-.14,8.11,8.11,0,0,0-1.07.15,2.82,2.82,0,0,0-1.4.6,3.12,3.12,0,0,0-.36.44s0-.06,0-.15a1.34,1.34,0,0,1,.24-.38,2.73,2.73,0,0,1,1.44-.73,10,10,0,0,1,1.1-.19,2.43,2.43,0,0,1,1.31.14,1.42,1.42,0,0,1,.59.45,1.55,1.55,0,0,1,.27.74,11.18,11.18,0,0,0,.08,1.46.94.94,0,0,0,1,.62,9.43,9.43,0,0,1,1.41,0,1.33,1.33,0,0,1,1.07.81,1.85,1.85,0,0,1,.09,1.15,3.22,3.22,0,0,1-.83,1.39C204.21,58.28,204.05,58.42,204,58.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "200.936px 54.7788px"
    },
    id: "elkyl914lp5f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.93,50l.3-.18a9.24,9.24,0,0,1,.93-.42,8.41,8.41,0,0,1,3.71-.58,5.81,5.81,0,0,1,2.49.78,5.45,5.45,0,0,1,2,2.21A5.62,5.62,0,0,1,217,55a5.44,5.44,0,0,1-1.64,3.15,5.67,5.67,0,0,1-3.21,1.53,5.38,5.38,0,0,1-3.24-.7,5.75,5.75,0,0,1-2.13-2.11,5.1,5.1,0,0,1-.66-2.54,5.6,5.6,0,0,1,1.25-3.51,3.73,3.73,0,0,1,1-.92,10.38,10.38,0,0,0-.93,1,5.63,5.63,0,0,0-1.12,3.43,5.15,5.15,0,0,0,.66,2.41,5.53,5.53,0,0,0,2.05,2,5.15,5.15,0,0,0,3.06.64,5.35,5.35,0,0,0,3-1.45,5,5,0,0,0,1.55-3,5.32,5.32,0,0,0-.53-3.1,5.14,5.14,0,0,0-1.9-2.11,5.77,5.77,0,0,0-2.38-.79,8.71,8.71,0,0,0-3.64.47C207.38,49.76,206.94,50,206.93,50Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "211.573px 54.2532px"
    },
    id: "elzs1jsrnwgb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.81,54.66a.21.21,0,0,1-.18-.21c0-.12.05-.22.14-.23s.16.08.17.2S208.9,54.65,208.81,54.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "208.786px 54.4396px"
    },
    id: "elagktoiuj34f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.63,53.3c-.08,0-.19-.09-.25-.26s0-.33,0-.36.2.09.26.26S212.72,53.27,212.63,53.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "212.522px 52.9877px"
    },
    id: "elxqew7qh67c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.07,53.57a1.69,1.69,0,0,1-.34.82A4.34,4.34,0,0,1,210,56.3a1.63,1.63,0,0,1-.87-.2,5,5,0,0,1,.87,0,4.93,4.93,0,0,0,1.95-.54,4.75,4.75,0,0,0,1.56-1.28C213.87,53.85,214,53.55,214.07,53.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "211.6px 54.9356px"
    },
    id: "elgumgheql1bs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.51,49.83c.06-.07.53.24,1.07.69s.91.87.86.93-.53-.24-1.07-.69S205.45,49.89,205.51,49.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "206.474px 50.6389px"
    },
    id: "el96hwo0x4pm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.63,49.28c.05-.07.46.19.92.58s.76.75.71.81-.47-.19-.92-.57S206.57,49.35,206.63,49.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "207.444px 49.9737px"
    },
    id: "elm786l4t9s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.36,48.17a3.07,3.07,0,0,1,.7,1.1c.3.64.49,1.19.41,1.23s-.39-.46-.7-1.1S208.28,48.21,208.36,48.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "208.915px 49.3361px"
    },
    id: "el6bzy9e3j5ip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.66,62.24s.05.08.13.24l.35.74c.3.68.72,1.61,1.24,2.76,1.05,2.41,2.5,5.74,4.19,9.59l.07.17-.19,0-5.91,1-6.66,1.08-.21,0,0-.21c.68-4,1.26-7.35,1.68-9.79.21-1.18.38-2.13.51-2.82.06-.31.11-.55.15-.75a.76.76,0,0,1,.07-.26,2.41,2.41,0,0,1,0,.27c0,.2-.06.45-.1.75-.11.7-.25,1.65-.43,2.84-.39,2.45-.93,5.85-1.57,9.81l-.17-.17,6.66-1.11,5.91-1-.11.21c-1.65-3.87-3.06-7.22-4.09-9.63-.48-1.17-.87-2.11-1.16-2.8l-.29-.75A1,1,0,0,1,201.66,62.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "201.155px 70.03px"
    },
    id: "el97b1gw2ekw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,84.42a16,16,0,0,1-.27-3.54,14.53,14.53,0,0,1,.25-3.53,29.06,29.06,0,0,1,.07,3.53A29.62,29.62,0,0,1,200,84.42Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "199.896px 80.885px"
    },
    id: "elfdm1fjbzk4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.59,84.14a24.49,24.49,0,0,1-.59-3.79,22.49,22.49,0,0,1-.27-3.83,24.49,24.49,0,0,1,.59,3.79A22.49,22.49,0,0,1,204.59,84.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "204.16px 80.33px"
    },
    id: "ells9dinzte7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.69,64.65a19,19,0,0,1-1.89,3.63,17.88,17.88,0,0,1-2.41,3.31c-.07,0,1-1.56,2.14-3.48S196.61,64.61,196.69,64.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "194.538px 68.1196px"
    },
    id: "elmqe3j7g8nx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.44,68.48A29.2,29.2,0,0,1,205,65.76a31.8,31.8,0,0,1-3.23-3,28.72,28.72,0,0,1,3.44,2.73A31.14,31.14,0,0,1,208.44,68.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "205.105px 65.62px"
    },
    id: "eltpjhk60k59f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.4,67.93a4.51,4.51,0,0,1,.2-1.28,24.29,24.29,0,0,1,.92-3,23.08,23.08,0,0,1,1.29-2.85,4.85,4.85,0,0,1,.69-1.1c.09,0-.83,1.79-1.69,4.06S207.49,68,207.4,67.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "208.953px 63.8159px"
    },
    id: "el8tiol3mdqns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.17,68.87a3.24,3.24,0,0,1-.65.26c-.42.14-1,.33-1.8.53s-1.7.4-2.74.57l-.8.12a4.15,4.15,0,0,1-.88.06,1,1,0,0,1-.47-.17.93.93,0,0,1-.32-.42,3.87,3.87,0,0,1-.16-.92c-.26-2.41-.48-4.59-.63-6.17-.06-.74-.11-1.37-.15-1.88a2.82,2.82,0,0,1,0-.69,2.86,2.86,0,0,1,.13.68c.07.51.16,1.13.26,1.86.2,1.58.45,3.76.71,6.17a4.09,4.09,0,0,0,.14.84.6.6,0,0,0,.54.39,3.7,3.7,0,0,0,.8,0l.79-.11c1-.15,2-.33,2.73-.5s1.4-.33,1.83-.43A2.39,2.39,0,0,1,219.17,68.87Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "214.859px 65.2865px"
    },
    id: "elrd937i9ljjb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.44,68.18a7.3,7.3,0,0,1-.55-1.5c-.3-.94-.7-2.25-1.12-3.69l-.57-2.05a17.26,17.26,0,0,1-.42-1.69,2.56,2.56,0,0,1,.07-1.19c.1-.27.22-.39.23-.38a2.65,2.65,0,0,0-.08,1.53c.23.94.68,2.24,1.08,3.69s.78,2.76,1,3.72A8.07,8.07,0,0,1,218.44,68.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "217.09px 62.9297px"
    },
    id: "ely7oq04kchjj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.41,62.17a9.64,9.64,0,0,1-2.41-1.8,10,10,0,0,1-2-2.26,26.41,26.41,0,0,1,2.2,2C219.42,61.26,220.46,62.1,220.41,62.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "218.206px 60.14px"
    },
    id: "el714kt0sa1gw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.32,83a12,12,0,0,1-.14-1.87c-.06-1.25-.13-2.8-.2-4.51s-.15-3.26-.21-4.51a13.7,13.7,0,0,1,0-1.88,9.92,9.92,0,0,1,.25,1.86c.1,1.15.22,2.75.3,4.52s.1,3.36.1,4.52A9.24,9.24,0,0,1,213.32,83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "213.084px 76.615px"
    },
    id: "eleppbm5dfm58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.74,82.49c0,.07-.25.34-.72.47s-.86,0-.85,0,.36-.15.77-.26S213.69,82.41,213.74,82.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "212.955px 82.7439px"
    },
    id: "elxq411kj4d6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.27,82.68a2.64,2.64,0,0,1-.68.1l-1.87.15h-.11v-.12c-.09-1.38-.22-3.24-.41-5.28s-.46-4.1-.64-5.51c-.08-.65-.16-1.21-.22-1.67a2.89,2.89,0,0,1,0-.62,2.38,2.38,0,0,1,.17.59c.08.39.19,1,.31,1.66.24,1.41.52,3.36.73,5.52s.3,3.92.33,5.3l-.12-.11,1.87,0A3.08,3.08,0,0,1,220.27,82.68Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "218.297px 76.33px"
    },
    id: "el32vnl8kyu9w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcxfaungxe9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.44,
    y: 112.7,
    width: 68.12,
    height: 48.27,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "276.5px 136.835px",
      transform: "rotate(-86.09deg)"
    },
    className: "animable",
    id: "elmqignag6q0r"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.25,172.46s0-.12,0-.33,0-.55.05-1c.05-.86.13-2.1.23-3.72.22-3.25.52-8,.91-14,.8-12,1.93-28.94,3.27-49l.16.18-48.15-3.28h0l.2-.17c-1.75,25.47-3.37,49-4.68,68l-.14-.16,35,2.47,9.71.7,2.55.19.88.08-.85,0-2.53-.16-9.68-.62-35.1-2.32h-.15v-.15c1.28-18.95,2.88-42.5,4.61-68V101h.19l48.15,3.31h.17v.17c-1.41,20.09-2.6,37.1-3.44,49.09-.43,6-.77,10.69-1,13.93-.12,1.6-.21,2.83-.27,3.68,0,.41-.06.72-.08.94A2.35,2.35,0,0,1,298.25,172.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "276.49px 136.73px"
    },
    id: "el8xw3t23u6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldi90635ycu7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.15,
    y: 94.31,
    width: 4.77,
    height: 11.82,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "261.535px 100.22px",
      transform: "rotate(-152.12deg)"
    },
    className: "animable",
    id: "el235q7mtcm36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9b0appqo64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.99,
    y: 164.23,
    width: 4.77,
    height: 11.82,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "298.375px 170.14px",
      transform: "rotate(-152.12deg)"
    },
    className: "animable",
    id: "el03xah2j4eu1a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.31,139.9a66.79,66.79,0,0,1,.31-7.27,70.68,70.68,0,0,1,.68-7.23,69.82,69.82,0,0,1-.31,7.26A71.49,71.49,0,0,1,264.31,139.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "264.804px 132.65px"
    },
    id: "el7ro5tif8oxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.39,120.38c.05.09-3.25,2-7.37,4.25s-7.5,4-7.55,3.92,3.25-2,7.37-4.25S275.34,120.29,275.39,120.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "267.93px 124.465px"
    },
    id: "eloqo6ah21old",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,127.87c-.05.09-3.39-1.41-7.46-3.34s-7.33-3.59-7.29-3.69,3.38,1.4,7.46,3.34S290,127.77,290,127.87Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "282.625px 124.355px"
    },
    id: "elradk1e6l2cb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.05,140.44a8.91,8.91,0,0,1-.06-1.89c0-1.17.08-2.77.23-4.55s.36-3.36.54-4.51a8.65,8.65,0,0,1,.38-1.85,8.78,8.78,0,0,1-.12,1.88c-.12,1.29-.26,2.82-.42,4.52s-.25,3.23-.35,4.52A9.18,9.18,0,0,1,286.05,140.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "286.557px 134.04px"
    },
    id: "el4pn0qchljin",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.86,140.83c0,.11-7.18-.3-16-.9s-16-1.18-16-1.29,7.18.31,16,.91S291.87,140.73,291.86,140.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "275.86px 139.735px"
    },
    id: "elnai85mzg7aa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.05,166.62a1.52,1.52,0,0,1,.35-.13l1-.29a16.64,16.64,0,0,0,3.64-1.47,7.67,7.67,0,0,0,2.05-1.7,6,6,0,0,0,1.31-2.73,4.2,4.2,0,0,0-.69-3.17,9,9,0,0,0-2.72-2.39,32.45,32.45,0,0,1-3.11-2.09,9.11,9.11,0,0,1-2.24-2.71,8.95,8.95,0,0,1,.55-9.46,7.63,7.63,0,0,1,.69-.83c.18-.18.27-.27.28-.26s-.34.4-.85,1.18A9.34,9.34,0,0,0,270,144.2a8.88,8.88,0,0,0,3.19,8.17,33.64,33.64,0,0,0,3.08,2.06,9.29,9.29,0,0,1,2.82,2.5,4.5,4.5,0,0,1,.72,3.44,6.27,6.27,0,0,1-1.41,2.86,7.62,7.62,0,0,1-2.16,1.73,15.29,15.29,0,0,1-3.73,1.38c-.46.11-.81.18-1.06.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "274.72px 153.005px"
    },
    id: "elrr5ky01faz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,168.09s.3-.39.8-1.09a13,13,0,0,0,1.64-3.26,8.21,8.21,0,0,0,.1-5.28,10.25,10.25,0,0,0-4.26-4.87,41.92,41.92,0,0,1-5.49-3.9,9,9,0,0,1-1.81-2.35,6.2,6.2,0,0,1-.67-2.5,5,5,0,0,1,1.07-3.53,2.86,2.86,0,0,1,1.1-.81,5.78,5.78,0,0,0-1,.91,4.92,4.92,0,0,0-.92,3.41,5.91,5.91,0,0,0,.67,2.38,9,9,0,0,0,1.78,2.24,44.1,44.1,0,0,0,5.46,3.84,10.5,10.5,0,0,1,4.38,5.07,8.49,8.49,0,0,1-.17,5.48,11.88,11.88,0,0,1-1.79,3.25c-.27.34-.49.6-.65.77S286.76,168.1,286.75,168.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "283.508px 154.295px"
    },
    id: "el2sp22vyhe86",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.68,133.58a14.74,14.74,0,0,1,0,3.4,16,16,0,0,1-.42,3.38,14.74,14.74,0,0,1,0-3.4A16,16,0,0,1,293.68,133.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "293.47px 136.97px"
    },
    id: "elxrzzah6ycq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.23,122.88a1.27,1.27,0,0,1,.8-.42,1.94,1.94,0,0,1,1.08.13,1.71,1.71,0,0,1,1,1.09l-.22,0a3.36,3.36,0,0,1,1.33-1.6,3.61,3.61,0,0,1,2.41-.56,3.55,3.55,0,0,1,2.73,4.6l-.3-.2a1.79,1.79,0,0,1,1.24-.43,2.62,2.62,0,0,1,1.24.42,2.59,2.59,0,0,1,.92,1,3,3,0,0,1,.26,1.33,5.49,5.49,0,0,1-.68,2.41,4.43,4.43,0,0,1-1.49,1.82,1.63,1.63,0,0,1-2.1-.27l.27-.11a2.23,2.23,0,0,1-1.42,2.32,2,2,0,0,1-2.05-.43,2,2,0,0,1-.67-1.17,1.19,1.19,0,0,1,0-.36c0-.08,0-.12,0-.12s0,.17.09.46a2.07,2.07,0,0,0,.69,1.06,1.8,1.8,0,0,0,1.85.33,2,2,0,0,0,1.21-2l-.09-.59.36.47a1.33,1.33,0,0,0,1.69.16,4.11,4.11,0,0,0,1.34-1.69,5.35,5.35,0,0,0,.63-2.26,2.59,2.59,0,0,0-.23-1.16,2.23,2.23,0,0,0-.78-.89,2.2,2.2,0,0,0-1.06-.36,1.4,1.4,0,0,0-1,.33l-.53.46L294,126a3.23,3.23,0,0,0-.34-2.73,3,3,0,0,0-2.08-1.42,3.38,3.38,0,0,0-2.22.48,3.15,3.15,0,0,0-1.26,1.45l-.14.32-.08-.34a1.56,1.56,0,0,0-.85-1,1.9,1.9,0,0,0-1-.17A2.31,2.31,0,0,0,285.23,122.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "291.476px 128.01px"
    },
    id: "eltinnr734tzk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.8,118.07a6.52,6.52,0,0,1,0,2.17,6.22,6.22,0,0,1-.34,2.16,6.63,6.63,0,0,1,0-2.18A6.07,6.07,0,0,1,279.8,118.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "279.63px 120.235px"
    },
    id: "elw8lyg7acw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.8,118.46c0,.1-.56.15-1.24.1s-1.22-.16-1.21-.27.56-.15,1.24-.1S282.81,118.36,282.8,118.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "281.575px 118.374px"
    },
    id: "eldspjbl6qk5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.56,124.69a13.32,13.32,0,0,1,0-3.12,12.37,12.37,0,0,1,.4-3.1,13.32,13.32,0,0,1,0,3.12A13,13,0,0,1,282.56,124.69Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "282.76px 121.58px"
    },
    id: "elfw17y9dklco",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.58,117.91a.87.87,0,0,1,.16-.26,1.91,1.91,0,0,1,.71-.55,3.27,3.27,0,0,1,1.42-.24,5.61,5.61,0,0,1,1.85.51,15.3,15.3,0,0,0,2.15.84,5.2,5.2,0,0,0,5.07-1.61,2.86,2.86,0,0,0,.71-1.34,1,1,0,0,0-.64-1.17l-.53-.15.52-.19a3.93,3.93,0,0,0,2.1-1.92,3.31,3.31,0,0,0,.06-3,3.24,3.24,0,0,0-3.55-1.88,3.12,3.12,0,0,0-2.4,2.89v.53l-.32-.43a1.51,1.51,0,0,0-1.52-.49,2,2,0,0,0-1.34.88,4.14,4.14,0,0,0-.38,3l0,.2-.2,0a4.08,4.08,0,0,0-2.56.32,4.54,4.54,0,0,0-1.57,1.22,5.23,5.23,0,0,0-.82,1.51,1.7,1.7,0,0,1,.09-.45,4.34,4.34,0,0,1,.61-1.15,4.75,4.75,0,0,1,1.6-1.32,4.27,4.27,0,0,1,2.71-.39l-.16.15a4.36,4.36,0,0,1,.38-3.2,2.32,2.32,0,0,1,1.53-1,1.84,1.84,0,0,1,1.87.61l-.31.1a3.46,3.46,0,0,1,2.65-3.25,3.24,3.24,0,0,1,2.32.33,4,4,0,0,1,1.66,1.75,3.67,3.67,0,0,1-.07,3.28,4.26,4.26,0,0,1-2.31,2.1v-.35a1.4,1.4,0,0,1,.88,1.57,3.06,3.06,0,0,1-.79,1.51,5.5,5.5,0,0,1-2.64,1.63,5.38,5.38,0,0,1-2.76,0,13.94,13.94,0,0,1-2.17-.89,5.22,5.22,0,0,0-1.77-.54,3.1,3.1,0,0,0-1.36.18A2.39,2.39,0,0,0,281.58,117.91Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "288.151px 112.638px"
    },
    id: "el05ldlbk6dbf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.37,138.18a14.71,14.71,0,0,1,.32-4.71,7.28,7.28,0,0,1,0,2.37A7.75,7.75,0,0,1,272.37,138.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "272.547px 135.825px"
    },
    id: "elxad27c77v9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.55,133.49a22.49,22.49,0,0,1-5.83-.4,22.49,22.49,0,0,1,5.83.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "275.635px 133.29px"
    },
    id: "el1szvs7qg015",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,139.32a11.69,11.69,0,0,1,0-3,12.4,12.4,0,0,1,.39-3,12.83,12.83,0,0,1,0,3A12.51,12.51,0,0,1,278,139.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "278.191px 136.32px"
    },
    id: "el1nwhy1lifvm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,127.57s.14,0,.33.14a1.5,1.5,0,0,1,.51.84,1.65,1.65,0,0,1-.3,1.44,1.67,1.67,0,0,1-2.87-1,1.72,1.72,0,0,1,.65-1.32,1.5,1.5,0,0,1,.92-.34c.24,0,.36.07.35.09a1.91,1.91,0,0,0-1.09.45,1.46,1.46,0,0,0-.48,1.11,1.25,1.25,0,0,0,.9,1.06,1.27,1.27,0,0,0,1.36-.28,1.48,1.48,0,0,0,.3-1.17A1.9,1.9,0,0,0,282,127.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "281.282px 128.918px"
    },
    id: "ely3zarkk8uas",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.51,127.66a1.79,1.79,0,0,0-.17.92,1.11,1.11,0,0,0,.5.77,1,1,0,0,0,1.05-.12.92.92,0,0,0,.38-1,1.11,1.11,0,0,0-.62-.68,1.69,1.69,0,0,0-.92-.07s.06-.11.23-.18a1.23,1.23,0,0,1,.79,0,1.35,1.35,0,0,1,.86.83,1.28,1.28,0,0,1-.49,1.38,1.29,1.29,0,0,1-1.46.12,1.35,1.35,0,0,1-.58-1,1.2,1.2,0,0,1,.2-.77C268.4,127.69,268.5,127.65,268.51,127.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "269.366px 128.518px"
    },
    id: "el18pgc6fbq4c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.92,110.55l.2,0a2,2,0,0,1,.56,0,3.23,3.23,0,0,1,1.77,1.08,3.32,3.32,0,0,1,.69,1.29,2.81,2.81,0,0,1-.07,1.69,3.39,3.39,0,0,1-3,2.15,2.7,2.7,0,0,1-1.89-.68,3.32,3.32,0,0,1-1-1.56,3.25,3.25,0,0,1-.05-1.69,2.68,2.68,0,0,1,.74-1.27,3,3,0,0,1,1.88-.86,1.44,1.44,0,0,1,.75.08s-.27,0-.74.06a3,3,0,0,0-1.7.91,2.63,2.63,0,0,0-.55,2.66,2.69,2.69,0,0,0,2.56,2,3.08,3.08,0,0,0,2.7-1.9,2.74,2.74,0,0,0-.51-2.68,3.14,3.14,0,0,0-1.6-1.1C266.19,110.58,265.92,110.59,265.92,110.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "266.14px 113.646px"
    },
    id: "el4ti66ojp2of",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.39,120.49c-.1,0-.18-.6-.18-1.33s.1-1.32.2-1.32.18.59.18,1.33S265.5,120.49,265.39,120.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "265.4px 119.165px"
    },
    id: "elgctwzgpqxik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.34,116.12c.06.08-.29.46-.78.84s-.95.63-1,.55.29-.46.79-.85S262.28,116,262.34,116.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "261.451px 116.808px"
    },
    id: "elcedqwejbs75",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,112.88c0,.09-.52.41-1.3.46s-1.39-.17-1.36-.27.62,0,1.33-.1S262,112.77,262,112.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "260.669px 113.09px"
    },
    id: "elyiy682vkc59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.87,110.35c0,.1-.75-.1-1.34-.77s-.7-1.42-.6-1.43.35.59.88,1.18S263.91,110.25,263.87,110.35Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "262.885px 109.262px"
    },
    id: "el1yz3h26bsnj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.34,106.93c.11,0,.19.6.19,1.33s-.09,1.32-.19,1.32-.19-.59-.19-1.32S266.24,106.93,266.34,106.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "266.34px 108.255px"
    },
    id: "elt38t11ftxhr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.86,110.46c.07.07-.24.45-.68.84s-.86.64-.93.56.24-.46.68-.84S270.79,110.38,270.86,110.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "270.055px 111.16px"
    },
    id: "elvsnst6thiqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.48,113.68A3.35,3.35,0,0,1,272,114c-.84,0-1.52,0-1.53-.1a3.24,3.24,0,0,1,1.51-.27C272.79,113.53,273.47,113.57,273.48,113.68Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "271.975px 113.787px"
    },
    id: "elfnz516ep0nr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.74,117.82c-.07.08-.49-.18-.93-.57s-.75-.78-.68-.86.49.18.93.58S270.8,117.75,270.74,117.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "269.934px 117.105px"
    },
    id: "eltt6xsg0fe4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbcqmun32pkt"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.97,
    y: 70.33,
    width: 52.81,
    height: 74.53,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "486.375px 107.595px",
      transform: "rotate(-10.74deg)"
    },
    className: "animable",
    id: "elq6tzpftutq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M519.26,139.29s0-.12-.08-.36l-.21-1c-.17-.92-.44-2.26-.78-4-.67-3.5-1.66-8.59-2.9-15-2.47-12.89-6-31.16-10.1-52.76l.22.15-51.88,9.86h0l.16-.24c5.19,27.44,10,52.81,13.85,73.23l-.2-.13,37.73-7.07L515.55,140l2.75-.51,1-.16-.92.19-2.71.54-10.42,2-37.8,7.25-.17,0,0-.17c-3.88-20.41-8.71-45.78-13.92-73.22l0-.2.2,0h0l51.88-9.82.18,0,0,.19L515.5,119l2.8,15c.31,1.73.56,3.06.73,4,.07.44.13.77.18,1S519.26,139.29,519.26,139.29Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "486.33px 107.605px"
    },
    id: "elqsub6o0ycg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elifzrv3a7smc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.79,
    y: 66.51,
    width: 5.22,
    height: 12.94,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "460.4px 72.98px",
      transform: "rotate(-166.77deg)"
    },
    className: "animable",
    id: "el2onn7vhy635"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwzfdv4ag20m"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.14,
    y: 130.34,
    width: 5.22,
    height: 12.94,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "518.75px 136.81px",
      transform: "rotate(-166.77deg)"
    },
    className: "animable",
    id: "el7ks2nhni2w4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M483,93.14a1.37,1.37,0,0,1,.73-.27,2.87,2.87,0,0,1,2.1.67,6.16,6.16,0,0,1,1.73,3.06c.4,1.31.84,2.8,1.29,4.46.89,3.31,1.83,7.3,2.63,11.77.39,2.23.77,4.58,1.07,7a6.05,6.05,0,0,1-.51,3.83,3.88,3.88,0,0,1-3.57,1.7,5.27,5.27,0,0,1-3.61-1.64,10,10,0,0,1-2.08-3.22,47.38,47.38,0,0,1-2.18-6.81,52.63,52.63,0,0,1-1.45-12c0-1.72.08-3.27.19-4.64a5.86,5.86,0,0,1,1.09-3.33,2.72,2.72,0,0,1,2-1,1.31,1.31,0,0,1,.76.16,3,3,0,0,0-.75-.06,2.71,2.71,0,0,0-1.82,1,5.66,5.66,0,0,0-1,3.23c-.08,1.35-.14,2.9-.11,4.61a53.84,53.84,0,0,0,1.55,11.87,48.48,48.48,0,0,0,2.17,6.72,10,10,0,0,0,2,3.07,4.81,4.81,0,0,0,3.27,1.48,3.32,3.32,0,0,0,3.1-1.45,5.57,5.57,0,0,0,.46-3.5c-.3-2.44-.66-4.79-1.05-7-.77-4.46-1.67-8.44-2.51-11.76-.42-1.66-.83-3.16-1.2-4.46a6,6,0,0,0-1.59-3,2.77,2.77,0,0,0-2-.72A3.26,3.26,0,0,0,483,93.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "485.906px 109.045px"
    },
    id: "elnq5l3dh23em",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.23,86.09s-.13.25-.3.7a3.42,3.42,0,0,0-.08,2,2.79,2.79,0,0,0,1.87,2,2.9,2.9,0,0,0,3.46-4.2,2.8,2.8,0,0,0-2.35-1.45,3.37,3.37,0,0,0-1.92.46c-.42.25-.6.46-.63.43s.11-.27.51-.59a3.31,3.31,0,0,1,2-.67,3.39,3.39,0,0,1,1.49.36,3.06,3.06,0,0,1,1.27,1.23,3.34,3.34,0,0,1-4,4.88,3,3,0,0,1-1.46-1,3.46,3.46,0,0,1-.63-1.39,3.29,3.29,0,0,1,.26-2.14A1.5,1.5,0,0,1,479.23,86.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "481.714px 88.1075px"
    },
    id: "elz0v86wtwv8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.17,83.31a4.83,4.83,0,0,1,1.92,1c1,.66,1.72,1.29,1.64,1.41s-.94-.32-1.93-1S476.09,83.43,476.17,83.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "477.95px 84.5248px"
    },
    id: "elxaf948ha45r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.91,80.85a5,5,0,0,1,0,2.23,5,5,0,0,1-.54,2.16,4.88,4.88,0,0,1,0-2.23A5,5,0,0,1,482.91,80.85Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "482.638px 83.045px"
    },
    id: "el7mld7irgfto",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,122.25s0,.07,0,.18a3.73,3.73,0,0,1-.21.52,6.58,6.58,0,0,1-1.18,1.76,7.61,7.61,0,0,1-2.75,1.94,7.13,7.13,0,0,1-4.43.4,7.9,7.9,0,0,1-4.53-2.91,9.82,9.82,0,0,1-1.7-6,47.77,47.77,0,0,1,.55-6.81,16.06,16.06,0,0,1,2.59-6.88,11.68,11.68,0,0,1,.8-1l.22.43a8,8,0,0,1-6.66-2.38,8.33,8.33,0,0,1-2.31-6.18,5.92,5.92,0,0,1,3-5.08,7.87,7.87,0,0,1,5.18-.47,12.28,12.28,0,0,1,6.45,3.7,11.91,11.91,0,0,1,1.24,1.62,5.18,5.18,0,0,1,.33.62,23.88,23.88,0,0,0-1.71-2.1,12.31,12.31,0,0,0-6.38-3.48,7.51,7.51,0,0,0-4.92.49,5.5,5.5,0,0,0-2.72,4.72,7.9,7.9,0,0,0,2.21,5.81,7.54,7.54,0,0,0,6.23,2.22l.65-.08-.43.51a10.71,10.71,0,0,0-.76.94,15.61,15.61,0,0,0-2.5,6.65,48.31,48.31,0,0,0-.58,6.72,9.42,9.42,0,0,0,1.56,5.7,7.56,7.56,0,0,0,4.28,2.81,7,7,0,0,0,4.23-.3,7.55,7.55,0,0,0,2.71-1.82A9.62,9.62,0,0,0,483,122.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "473.19px 108.383px"
    },
    id: "elpbeap91q2mr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.11,118.08a8.06,8.06,0,0,0,1.95,1.34,7,7,0,0,0,2.69.63,7.58,7.58,0,0,0,3.58-.75,7.31,7.31,0,0,0,3.1-3.13,9,9,0,0,0,1-5c-.32-3.68-3.32-7.27-7.41-8.7l-.62-.22L497,102a14.89,14.89,0,0,0,3.84-2.37,10,10,0,0,0,3.48-6,7.74,7.74,0,0,0-1.52-6.13A7.47,7.47,0,0,0,497.59,85a8.81,8.81,0,0,0-5,1.11,10.69,10.69,0,0,0-3.2,2.85,14.07,14.07,0,0,0-1.63,2.83,27.86,27.86,0,0,0-.89,2.65,3,3,0,0,1,.1-.72,14,14,0,0,1,.6-2,13.24,13.24,0,0,1,1.59-2.92,10.84,10.84,0,0,1,3.24-3,9,9,0,0,1,5.2-1.23,7.89,7.89,0,0,1,5.52,2.63,8.19,8.19,0,0,1,1.65,6.52,10.43,10.43,0,0,1-3.64,6.27,14.87,14.87,0,0,1-4,2.45V102c4.25,1.5,7.37,5.26,7.68,9.15a9.25,9.25,0,0,1-1,5.25,7.61,7.61,0,0,1-3.31,3.25,7.82,7.82,0,0,1-3.74.71,7.15,7.15,0,0,1-2.76-.73,5.9,5.9,0,0,1-1.47-1A2.92,2.92,0,0,1,492.11,118.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "495.883px 102.461px"
    },
    id: "el2aso51pqwn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.34,110.1a1.7,1.7,0,0,1,1,.27,3.72,3.72,0,0,1,1.73,2.26,8.17,8.17,0,0,1-.22,4.23,6.32,6.32,0,0,1-1.06,2.31,3,3,0,0,1-1.1.88,2.67,2.67,0,0,1-1.45.21,3.55,3.55,0,0,1-2.39-1.41,4.62,4.62,0,0,1-.82-2.43,7.81,7.81,0,0,1,1-4.11,7.9,7.9,0,0,1,1.8-2.2,2.86,2.86,0,0,1,.86-.58,12,12,0,0,0-2.34,3,7.54,7.54,0,0,0-.89,3.89,4.14,4.14,0,0,0,.75,2.17,3.1,3.1,0,0,0,2,1.2,2.29,2.29,0,0,0,2.1-.9,5.93,5.93,0,0,0,1-2.12,7.9,7.9,0,0,0,.33-4,3.73,3.73,0,0,0-1.47-2.19A10.08,10.08,0,0,0,476.34,110.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "475.637px 114.907px"
    },
    id: "elag7dp1f5tg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.12,94.11s.09-.14.34-.21a1.57,1.57,0,0,1,1.08.14,1.83,1.83,0,0,1,1,1.3,1.82,1.82,0,0,1-3,1.47,1.8,1.8,0,0,1-.4-1.6,1.56,1.56,0,0,1,.56-.93c.21-.16.36-.17.37-.15s-.48.34-.57,1.14a1.48,1.48,0,0,0,.39,1.2,1.23,1.23,0,0,0,1.42.15,1.27,1.27,0,0,0,.77-1.22,1.5,1.5,0,0,0-.71-1A2.11,2.11,0,0,0,468.12,94.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "468.817px 95.5532px"
    },
    id: "elnosq5c94ay",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.05,88.22s.11-.19.47-.22a1.5,1.5,0,0,1,1.25.67,2.45,2.45,0,0,1-1.64,3.78,2.22,2.22,0,0,1-1.39-.26,2,2,0,0,1-.86-1,1.84,1.84,0,0,1,.35-2.08,1.8,1.8,0,0,1,1.33-.52c.34,0,.5.15.48.17s-.18,0-.48,0a1.65,1.65,0,0,0-1.06.56,1.47,1.47,0,0,0-.19,1.63,1.63,1.63,0,0,0,1.75.92,1.92,1.92,0,0,0,1.56-1.31,2.09,2.09,0,0,0-.15-1.74,1.42,1.42,0,0,0-1-.68C498.23,88.16,498.07,88.26,498.05,88.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "497.943px 90.2357px"
    },
    id: "elqcqp2lpdkw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496,106a2.17,2.17,0,0,1,1.13-.08A4.77,4.77,0,0,1,500,107.2a5.76,5.76,0,0,1,1.65,4.27,5.24,5.24,0,0,1-.78,2.65,3.37,3.37,0,0,1-2.51,1.64,5.28,5.28,0,0,1-2.87-.75,7.11,7.11,0,0,1-2.23-1.62,3.27,3.27,0,0,1-.79-2.39,4.41,4.41,0,0,1,.67-2.08,7.06,7.06,0,0,1,2.24-2.13,3.77,3.77,0,0,1,1-.52,6.55,6.55,0,0,1-.88.69,7.33,7.33,0,0,0-2,2.15,4.07,4.07,0,0,0-.56,1.91,2.82,2.82,0,0,0,.73,2.06,6.66,6.66,0,0,0,2.09,1.48,5,5,0,0,0,2.6.69,2.91,2.91,0,0,0,2.12-1.4,4.83,4.83,0,0,0,.73-2.4,5.49,5.49,0,0,0-1.43-4,4.83,4.83,0,0,0-2.55-1.39C496.44,105.94,496,106,496,106Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "497.058px 110.821px"
    },
    id: "elgnaphm73rt7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.23,102.94a43.52,43.52,0,0,0-4.76.23,42.23,42.23,0,0,0-4.6,1.29,11.21,11.21,0,0,1,9.36-1.52Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "484.55px 103.488px"
    },
    id: "elr8oc3b1zmhh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.42,96.86a16.67,16.67,0,0,0-4,.42,16,16,0,0,0-3.61,1.86s.22-.45.81-1a7.58,7.58,0,0,1,5.64-1.68C487,96.61,487.44,96.8,487.42,96.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "483.615px 97.7774px"
    },
    id: "elxrgtxtkfm6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.94,110.58a40.2,40.2,0,0,1-4.18.72,41.42,41.42,0,0,1-4.18.81,16.29,16.29,0,0,1,8.36-1.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "485.76px 111.317px"
    },
    id: "elpe4vpzpp5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.65,116.8a26.9,26.9,0,0,1-7.08,2.25,26.9,26.9,0,0,1,7.08-2.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "487.11px 117.925px"
    },
    id: "el0mf3mdykluci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.53,135.4a16.63,16.63,0,0,1-1.58-5,16.61,16.61,0,0,1-.45-5.24c.15,0,.4,2.32,1,5.14S489.67,135.35,489.53,135.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "488.503px 130.28px"
    },
    id: "ellq033we3hp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.06,133.15a18.62,18.62,0,0,1-2.57-4.39,18.91,18.91,0,0,1-1.77-4.77,37,37,0,0,1,2.24,4.55A38.35,38.35,0,0,1,497.06,133.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "494.89px 128.57px"
    },
    id: "ell7kbqb9x03s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "576.34 441.28 576.34 479.41 632.1 479.41 693.59 479.41 693.59 441.28 576.34 441.28",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "634.965px 460.345px"
    },
    id: "elf4wxsqfqrz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "571.42 430.62 571.42 441.28 697.69 441.28 697.69 430.62 632.1 430.62 571.42 430.62",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "634.555px 435.95px"
    },
    id: "elmo9ffb75u7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "634.56 479.41 693.59 479.41 693.59 441.28 697.69 441.28 697.69 430.62 632.1 430.62 632.1 440.29 634.56 479.41",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "664.895px 455.015px"
    },
    id: "el2h6wy1mvbth",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.74,
    y: 447.43,
    width: 23.78,
    height: 5.74,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "604.63px 450.3px"
    },
    id: "el9gbfuburqyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.68,
    y: 460.34,
    width: 30.53,
    height: 12.12,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "604.945px 466.4px"
    },
    id: "elw09znl5wyhg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "594.38 392.54 594.38 430.67 650.14 430.67 711.63 430.67 711.63 392.54 594.38 392.54",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "653.005px 411.605px"
    },
    id: "el94mtjr70xpd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "589.46 381.88 589.46 392.54 715.73 392.54 715.73 381.88 650.14 381.88 589.46 381.88",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "652.595px 387.21px"
    },
    id: "eljfs8iywi4og",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "652.6 430.67 711.63 430.67 711.63 392.54 715.73 392.54 715.73 381.88 650.14 381.88 650.14 391.56 652.6 430.67",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "682.935px 406.275px"
    },
    id: "eli8c7ncnbfw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.78,
    y: 398.69,
    width: 23.78,
    height: 5.74,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "622.67px 401.56px"
    },
    id: "elb7jsqeu66ic",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.72,
    y: 411.61,
    width: 30.53,
    height: 12.12,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "622.985px 417.67px"
    },
    id: "elxmddgkehirg",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "375px 479.41px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699.69,479.41c0,.14-145.38.26-324.67.26s-324.71-.12-324.71-.26,145.35-.26,324.71-.26S699.69,479.26,699.69,479.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375px 479.41px"
    },
    id: "elnabe70v5s2g",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2",
    className: "animable",
    style: {
      transformOrigin: "368.43px 346.737px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.35,
    y: 282.53,
    width: 13.05,
    height: 195.63,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "434.875px 380.345px"
    },
    id: "elopj2mojrjw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.73,
    y: 263.49,
    width: 319.4,
    height: 19.04,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "368.43px 273.01px"
    },
    id: "elg2bx992tujn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.34,
    y: 282.53,
    width: 13.05,
    height: 195.63,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "279.865px 380.345px"
    },
    id: "elzbudx5edgeb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.35,282.09c0,.15-52.94.26-118.23.26s-118.25-.11-118.25-.26,52.93-.26,118.25-.26S446.35,282,446.35,282.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "328.11px 282.09px"
    },
    id: "eli7vo4hlcu4g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.34,215.5a6.27,6.27,0,0,0-3.08,10.41H304.64V241h0a6.3,6.3,0,1,1,0,5.53h0v16.94h37.58V225.91h-14.8a6.28,6.28,0,0,0-6.08-10.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "323.43px 239.392px"
    },
    id: "ell4lul2vebpa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.41,242.24a6.2,6.2,0,0,0-4.34-4.54,6.29,6.29,0,0,0-6.06,1.46h0l-.14-13.35h-18a6.3,6.3,0,1,1-5.53,0H267.13v37.58h39.1L306,248.32h0A6.2,6.2,0,0,0,310.3,250,6.29,6.29,0,0,0,316.41,242.24Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "291.857px 244.6px"
    },
    id: "elgjwtc58pzce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluf0zogof1bj"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "273.365px 235.146px"
    },
    className: "animable",
    id: "eljl9tupuvwsi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267,244.28a7.67,7.67,0,0,0,7-1.56,9.25,9.25,0,0,0,3.13-6.58,11.69,11.69,0,0,0-2.08-7.07l4.68-3.33H267.13Z",
    id: "elf8xe4u027o",
    className: "animable",
    style: {
      transformOrigin: "273.365px 235.146px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-2",
    className: "animable animator-active",
    style: {
      transformOrigin: "666.704px 94.5298px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.29,127,637,113.47a36.19,36.19,0,1,1,8.67,9.65v0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "666.65px 94.5001px"
    },
    id: "elytev02kx7j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.29,127l16.32-4-.07.2h0a.12.12,0,0,1,0-.18.12.12,0,0,1,.16,0A36.07,36.07,0,0,0,663,130.19a33,33,0,0,0,5.67.26c1-.06,2-.08,3-.17l3-.47a36.08,36.08,0,0,0,22.31-14.39,35.73,35.73,0,0,0,6-13.8,36.32,36.32,0,0,0-.44-15.88,35.11,35.11,0,0,0-7.65-14.67,35.7,35.7,0,0,0-13.75-9.82,36.56,36.56,0,0,0-16-2.48,35.33,35.33,0,0,0-14.7,4.33,36.34,36.34,0,0,0-17,20.84,38.7,38.7,0,0,0-1.6,11.64,36,36,0,0,0,5.26,17.83.11.11,0,0,1,0,.12c-5,8.55-7.34,12.69-7.78,13.46.43-.77,2.75-4.95,7.56-13.58v.13a36.11,36.11,0,0,1-5.41-18A39.22,39.22,0,0,1,633,83.82a36.7,36.7,0,0,1,17.18-21.14,35.73,35.73,0,0,1,14.89-4.41,37,37,0,0,1,16.23,2.5,36.3,36.3,0,0,1,13.94,9.95A35.68,35.68,0,0,1,703,85.61a36.91,36.91,0,0,1,.43,16.11,36.11,36.11,0,0,1-6.12,14,36.5,36.5,0,0,1-22.62,14.52l-3.06.46c-1,.08-2,.1-3,.16a32.7,32.7,0,0,1-5.73-.29,36.12,36.12,0,0,1-17.36-7.33l.18-.18,0,0a.13.13,0,0,1,0,.18l-.05,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "666.704px 94.5298px"
    },
    id: "el4xkx6uiyvg2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673,90.62h-2.23l-4.88-6.8V79.36s-3.45-.21-3,5.63,0,4.35,0,4.35-7.33,0-7.94.67c-.44.46-.64,7.74-.72,11.69a4.28,4.28,0,0,0,3,4.31,3.07,3.07,0,0,0,.79.11c1.83,0,11.17-1.49,11.17-1.49H673Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "663.612px 92.7395px"
    },
    id: "elc9fddonuuee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "679.37 89.39 678 104.67 674.17 104.67 674.17 89.7 679.37 89.39",
    style: {
      fill: "#96BBCE",
      transformOrigin: "676.77px 97.03px"
    },
    id: "el2yb59rtt189",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-2",
    className: "animable",
    style: {
      transformOrigin: "80.9668px 118.601px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.49,143.09s-.37.06-1,.3a4.52,4.52,0,0,0-2,1.75,4.35,4.35,0,0,0-.63,1.75,3.71,3.71,0,0,0,.37,2.06,4,4,0,0,0,7.57-.44,3.71,3.71,0,0,0,.12-2.1,4.46,4.46,0,0,0-3.07-3.16,9.77,9.77,0,0,0-1-.18.76.76,0,0,1,.26,0,1.92,1.92,0,0,1,.33,0,2,2,0,0,1,.43.08,4.5,4.5,0,0,1,3.29,3.21,4,4,0,0,1-.1,2.25,4.58,4.58,0,0,1-1.41,2.05,4.07,4.07,0,0,1-5.05.3,4.59,4.59,0,0,1-1.64-1.87,3.93,3.93,0,0,1-.37-2.23,4.46,4.46,0,0,1,.7-1.83,4.41,4.41,0,0,1,2.19-1.74,3.25,3.25,0,0,1,.42-.13,1.48,1.48,0,0,1,.32-.05A.79.79,0,0,1,113.49,143.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "113.917px 147.378px"
    },
    id: "elkx5a9i8jsc9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.71,121.29s0-.19,0-.55,0-.91,0-1.62c0-.35,0-.75,0-1.19s-.06-.91-.1-1.43-.08-1.08-.13-1.67a6,6,0,0,0-.12-.92c-.06-.31-.12-.63-.17-1a32.33,32.33,0,0,0-3-9.3,33.67,33.67,0,0,0-7.84-10.25L99,92.2c-.49-.38-1-.73-1.51-1.1l-.77-.56a8.42,8.42,0,0,0-.8-.52l-1.69-1c-.28-.17-.57-.34-.86-.49l-.91-.42-1.84-.84c-.63-.26-1.3-.45-1.95-.69l-1-.34-.5-.16L86.64,86a30.58,30.58,0,0,0-4.22-.83c-.73-.08-1.46-.21-2.2-.26L78,84.83c-.38,0-.75,0-1.13,0l-1.14.08c-.76.07-1.53.1-2.3.2a35.49,35.49,0,0,0-4.6,1l-1.15.33-.58.16-.56.22-2.26.88c-.75.33-1.46.73-2.2,1.09-.36.2-.75.36-1.1.58L59.91,90a38,38,0,0,0-4.08,3L54,94.69l-.47.45-.43.48-.85,1-.86,1-.76,1.05-.77,1.07-.38.53c-.12.19-.22.38-.33.57l-1.34,2.29c-.36.81-.73,1.61-1.11,2.43A33.5,33.5,0,0,0,45,126.79l.72,2.57,1,2.47.24.61.3.59.59,1.17.59,1.16.7,1.1.69,1.09.35.55.39.51c.53.67,1.05,1.35,1.57,2a38.57,38.57,0,0,0,3.57,3.55l.94.82c.31.28.66.49,1,.74.67.48,1.32,1,2,1.42l2.1,1.22.52.31.55.25,1.08.5a36.74,36.74,0,0,0,4.4,1.67c.74.21,1.5.36,2.24.54l1.11.26c.37.08.75.11,1.12.16l2.23.29c.74.07,1.48.06,2.21.09a32.22,32.22,0,0,0,4.3-.16l.53,0,.52-.09,1-.18c.68-.13,1.37-.21,2-.38l2-.54,1-.27.92-.35,1.82-.71a6.79,6.79,0,0,0,.87-.39l.85-.43c.56-.29,1.12-.55,1.66-.85l1.55-1a33.89,33.89,0,0,0,9.33-8.91c.28-.39.56-.77.82-1.15s.46-.79.69-1.17.44-.76.66-1.13c.1-.19.22-.37.31-.55s.18-.38.26-.57l1-2.13c.29-.69.49-1.38.72-2,.11-.32.21-.63.32-.93a6.23,6.23,0,0,0,.26-.88l.39-1.63c.11-.51.24-1,.32-1.4s.11-.83.16-1.18c.1-.7.17-1.24.22-1.6l.09-.55s0,.19,0,.55-.11.9-.2,1.61c0,.35-.09.74-.14,1.18s-.2.9-.31,1.41-.24,1-.37,1.63a6.47,6.47,0,0,1-.26.9l-.32.93c-.22.64-.42,1.33-.71,2l-1,2.15-.26.57c-.09.19-.21.37-.31.55q-.33.56-.66,1.14c-.23.39-.45.78-.69,1.18s-.54.77-.82,1.16a33.8,33.8,0,0,1-9.35,9l-1.55,1c-.54.3-1.11.57-1.68.86l-.85.43a5.39,5.39,0,0,1-.88.4l-1.82.72-.94.35-1,.28-2,.55c-.67.17-1.36.25-2,.39l-1,.18c-.18,0-.35.07-.53.09l-.53,0a32.82,32.82,0,0,1-4.34.17c-.74,0-1.48,0-2.22-.08l-2.25-.29c-.37-.06-.75-.08-1.13-.16l-1.12-.26c-.75-.19-1.51-.33-2.26-.55a36.32,36.32,0,0,1-4.44-1.68l-1.09-.5a5.52,5.52,0,0,1-.55-.26l-.53-.3-2.12-1.23c-.69-.45-1.34-.95-2-1.43-.33-.25-.69-.47-1-.74l-.94-.83a39.32,39.32,0,0,1-3.61-3.58l-1.59-2-.39-.51-.36-.55-.69-1.11-.71-1.1-.59-1.18-.6-1.18-.3-.59L46.4,132c-.32-.83-.64-1.66-1-2.49l-.72-2.59a33.87,33.87,0,0,1,1.67-21.49c.38-.82.75-1.63,1.13-2.44s.89-1.55,1.34-2.31c.11-.2.22-.39.34-.58l.39-.54.77-1.07.77-1.06.87-1,.86-1c.14-.16.28-.33.43-.49l.47-.44,1.88-1.77a37.71,37.71,0,0,1,4.12-3l1.06-.67c.36-.22.74-.39,1.11-.58.74-.37,1.47-.77,2.22-1.1l2.28-.88.57-.22a5.54,5.54,0,0,1,.58-.17l1.16-.33a36.48,36.48,0,0,1,4.64-1c.78-.09,1.55-.12,2.32-.19l1.15-.08c.38,0,.76,0,1.14,0l2.26.06c.75,0,1.48.18,2.21.26a31.18,31.18,0,0,1,4.26.85l.52.12.5.17,1,.34c.66.23,1.33.43,2,.7l1.86.85.91.42.87.49,1.69,1a7.6,7.6,0,0,1,.81.54l.77.56c.52.37,1,.73,1.52,1.11l1.38,1.21a33.87,33.87,0,0,1,7.85,10.35,32.41,32.41,0,0,1,3,9.34c0,.34.11.66.16,1a6,6,0,0,1,.12.92c0,.59.08,1.15.12,1.67s.08,1,.08,1.44,0,.84,0,1.19c0,.71,0,1.25-.06,1.62S111.71,121.29,111.71,121.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "77.749px 118.601px"
    },
    id: "el8m8etppfmll",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.79,118.64a2.93,2.93,0,1,1-2.93-2.93A2.93,2.93,0,0,1,68.79,118.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "65.86px 118.64px"
    },
    id: "elucrp13pte2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.53,118.64a2.94,2.94,0,1,1-2.94-2.93A2.94,2.94,0,0,1,80.53,118.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "77.59px 118.65px"
    },
    id: "eliirriqpdbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.23,117.18a2.93,2.93,0,1,1-4-1.08A2.93,2.93,0,0,1,92.23,117.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.6899px 118.64px"
    },
    id: "eli7l497tjd5",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2",
    className: "animable",
    style: {
      transformOrigin: "514.673px 266.421px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elbx281eiei66"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 482.71,
    y: 407.98,
    width: 131.79,
    height: 10.58,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "548.605px 413.27px",
      transform: "rotate(-90deg)"
    },
    className: "animable",
    id: "el31g142icrdv"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 511.42,
    y: 335.71,
    width: 128.08,
    height: 20.48,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "575.46px 345.95px"
    },
    id: "el5ouwugflki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8dkcgmp66qs"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.88,
    y: 407.98,
    width: 131.79,
    height: 10.58,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "525.775px 413.27px",
      transform: "rotate(-90deg)"
    },
    className: "animable",
    id: "elgq65e3jxtw6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elsktz8rjk5id"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.8,
    y: 407.98,
    width: 131.79,
    height: 10.58,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "595.695px 413.27px",
      transform: "rotate(-90deg)"
    },
    className: "animable",
    id: "el21gk2be12j5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elq0kp2q2t4u"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.92,
    y: 407.98,
    width: 131.79,
    height: 10.58,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "623.815px 413.27px",
      transform: "rotate(-90deg)"
    },
    className: "animable",
    id: "el5tj24zfr8e5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M617,356.19a102.25,102.25,0,0,1-.26-10.24,102.42,102.42,0,0,1,.26-10.24,98.94,98.94,0,0,1,.26,10.24A98.78,98.78,0,0,1,617,356.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "617.002px 345.95px"
    },
    id: "el157ycklrj36",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.45,356.19c0,.15-28.43.26-63.51.26s-63.52-.11-63.52-.26,28.44-.26,63.52-.26S638.45,356.05,638.45,356.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "574.935px 356.19px"
    },
    id: "elymz0zp6aaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.41,
    y: 408.37,
    width: 89.81,
    height: 8.75,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "575.315px 412.745px"
    },
    id: "el9ciatwmoj4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.35,208.34a6.28,6.28,0,0,0-1.13,10.79h0l-13.1,2.58.21,1.14,3.09,16.6h0a6.28,6.28,0,1,1,1,5.44h0l2.77,14.9h0l36.95-6.87h0L438.28,216l-.28-1.5-14.77,3h0a6.28,6.28,0,0,0-7.88-9.12Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "423.13px 233.803px"
    },
    id: "elenmxmto6enj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.29,182.76c-.51.68-18.89,33.48-18.89,33.48l-41.23,9.12,3.37,18.79s45.46-4.88,51.87-9.92,21.37-35.69,21.37-35.69Z",
    style: {
      fill: "rgb(147, 103, 96)",
      transformOrigin: "491.475px 213.455px"
    },
    id: "elbq47ijbbsud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.17,225.36l-12.58,1.32c-.56.06-12.15,6.38-12.15,6.38s-.9,1.23,2.88,1.09a41.49,41.49,0,0,0,9.28-2l3.72,16.37L457.49,244l2.1-15.14Z",
    style: {
      fill: "rgb(147, 103, 96)",
      transformOrigin: "443.968px 236.94px"
    },
    id: "elpbqx8mm2ovk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.05,277.25s-80.5-.34-86.88,0c-11.35.61-19,13.28-20.47,19.85S425,404.84,425,404.84l27.33,17.68L489,339.77l18.46-32.1,100.4,17.54Z",
    style: {
      fill: "rgb(147, 103, 96)",
      transformOrigin: "516.43px 349.809px"
    },
    id: "elt0wizwiga4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507,304.7s-14.86,0-22.89,11.89c-4.71,7-3.06,19.48-3.15,28.9-.13,12.84,3.21,112.41,3.21,112.41,9.47,6.73,20.05,7.5,31.61,3l8.18-110.22-2.11-16.44,54.91,1.21s9.78-18.3-3.81-32.82C571.15,300.75,507,304.7,507,304.7Z",
    style: {
      fill: "rgb(147, 103, 96)",
      transformOrigin: "530.458px 382.926px"
    },
    id: "elvtpzuq1thk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.13,456.86l0,2s-34.46,13.44-34.89,19.95l68.16.32-.82-22.68C506.39,461.13,495.79,461.6,484.13,456.86Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "483.32px 467.79px"
    },
    id: "el5zsa83wx58t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.37,479.16l-.2-5.45-65.25,1.68s-3,1.31-2.71,3.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "483.28px 476.435px"
    },
    id: "el8i13boh531o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.32,400.63l-.77,1.87s-37-.21-39.78,5.68L449,433.61l7.6-21.38C445.45,412.8,435.41,409.33,426.32,400.63Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "421.185px 417.12px"
    },
    id: "elya6pmh7d60c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,433.61l1.83-5.14L389.55,406s-3.3.09-3.78,2.2Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "418.3px 419.805px"
    },
    id: "elsrvmdidyse",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,410.26c.08,0,.4-.36.67-1.14a6.55,6.55,0,0,0,.23-3.19,6.64,6.64,0,0,0-1.25-2.94c-.52-.65-.95-.92-1-.86s1.19,1.61,1.55,3.92S422.79,410.18,423,410.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "422.824px 406.191px"
    },
    id: "elul92wu02r0m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.61,410.88c.16.09,1-1.87.6-4.38s-1.89-4.07-2-3.93.92,1.75,1.3,4.06S426.39,410.82,426.61,410.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "426.259px 406.722px"
    },
    id: "elfe79l4b29v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.49,409.8c.14.14,1.35-1.21,1.6-3.33s-.55-3.73-.72-3.63.26,1.62,0,3.54S417.31,409.68,417.49,409.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "418.301px 406.323px"
    },
    id: "elydgphj1hj2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.26,402.67c0,.08.95-.4,1.88-1.69a12.57,12.57,0,0,0,1.33-2.42c.2-.47.4-1,.6-1.5a4.73,4.73,0,0,0,.27-.87,1.31,1.31,0,0,0-.31-1.12,1,1,0,0,0-1.23-.15,2.29,2.29,0,0,0-.74.66,8,8,0,0,0-.86,1.43,8.12,8.12,0,0,0-.76,2.68,4.3,4.3,0,0,0,.27,2.52c.12,0,0-1,.24-2.44a9,9,0,0,1,.85-2.46,7.61,7.61,0,0,1,.83-1.29c.29-.41.75-.65.88-.44s.1.71-.11,1.24-.37,1-.56,1.48a14.94,14.94,0,0,1-1.13,2.39C421.94,402,421.18,402.58,421.26,402.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "423.309px 398.726px"
    },
    id: "elcc7c2efr5i6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.9,402.31s.05.15.24.36l.15.16,0-.24a8.51,8.51,0,0,0-.17-2.87,10.89,10.89,0,0,0-1.32-3.26,2.13,2.13,0,0,0-.49-.58,1.1,1.1,0,0,0-.93-.23,1,1,0,0,0-.7,1,3.19,3.19,0,0,0,.13.87,8.74,8.74,0,0,0,.5,1.47,9.06,9.06,0,0,0,1.39,2.2,4.36,4.36,0,0,0,1.86,1.48c.08-.1-.63-.66-1.45-1.8A10.13,10.13,0,0,1,419,398.7a11,11,0,0,1-.42-1.37c-.15-.5-.12-1,0-1,.4-.14.89.92,1.23,1.53a12.16,12.16,0,0,1,.77,2,16.37,16.37,0,0,1,.51,2.71l.19-.08C421.05,402.34,420.92,402.28,420.9,402.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "419.623px 399.228px"
    },
    id: "eliqhfxyvvut8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.71,466.65c.09,0,.16-.52,0-1.32a6.57,6.57,0,0,0-1.47-2.84,6.66,6.66,0,0,0-2.61-1.85c-.78-.29-1.3-.29-1.31-.2s1.85.75,3.37,2.53S484.5,466.69,484.71,466.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "482.063px 463.519px"
    },
    id: "elcflbytmbt8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.12,465.29c.19,0-.09-2.14-1.78-4.05s-3.74-2.48-3.77-2.29,1.7,1,3.22,2.77S487.91,465.35,488.12,465.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "485.371px 462.103px"
    },
    id: "elcch9m7dxwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.79,469.14c.19,0,.51-1.74-.38-3.68s-2.43-2.89-2.52-2.72,1.07,1.25,1.85,3S479.57,469.13,479.79,469.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "478.445px 465.93px"
    },
    id: "elt20fc3nwdaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.27,461.09a4.11,4.11,0,0,0,.71-2.43,13.35,13.35,0,0,0-.13-2.75c-.07-.52-.17-1.05-.27-1.59a4.5,4.5,0,0,0-.23-.89,1.27,1.27,0,0,0-.85-.79,1,1,0,0,0-1.13.51,2.27,2.27,0,0,0-.28,1,7.65,7.65,0,0,0,0,1.66,8.58,8.58,0,0,0,.76,2.69c.71,1.43,1.49,2.06,1.55,2s-.53-.81-1.07-2.21a8.62,8.62,0,0,1-.54-4.07c0-.5.31-.94.52-.83s.46.55.56,1.11.2,1,.3,1.55a16.3,16.3,0,0,1,.29,2.63C479.49,460.15,479.16,461.05,479.27,461.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "478.523px 456.85px"
    },
    id: "eljh6r5t3whef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.77,461s.12.1.4.18l.21.06-.1-.23a8.48,8.48,0,0,0-1.64-2.35,10.76,10.76,0,0,0-1.73-1.45,12.73,12.73,0,0,0-1.1-.64,2.09,2.09,0,0,0-.73-.24,1.09,1.09,0,0,0-.9.29,1,1,0,0,0-.1,1.19,3.71,3.71,0,0,0,.57.68,9,9,0,0,0,1.2,1,8.79,8.79,0,0,0,2.33,1.15,4.33,4.33,0,0,0,2.36.28c0-.12-.88-.22-2.18-.77a10.25,10.25,0,0,1-2.12-1.21,9.42,9.42,0,0,1-1.08-.95c-.39-.34-.62-.78-.47-.84.27-.33,1.24.31,1.84.66a11.42,11.42,0,0,1,1.7,1.28,17,17,0,0,1,1.86,2.05l.11-.17C478.92,460.92,478.78,460.93,478.77,461Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "476.235px 458.78px"
    },
    id: "elsbuzgwweh6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.51,68.89a21.48,21.48,0,0,1,10.64-12.71c5.56-2.83,12.17-3.07,18.25-1.67s11.69,4.32,17,7.6c3,1.84,5.94,3.85,8,6.65,3.82,5.11,7.52,13.43,7.72,19.81.16,5.16-2.18,18-4.49,22.61-.82,1.65-2.75,3.1-5.07,4.32a43.87,43.87,0,0,1-9.68,12.08q-1.65-5.23-3.29-10.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "568.319px 90.6282px"
    },
    id: "elns5z9kij1qd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.66,62.62l10.2-1.53c-5.92,13.06-8.29,43.24-11.86,57.13-3.59-5.53-11.81-22.32-11.16-28.89S528.63,61.15,540.66,62.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "539.332px 89.655px"
    },
    id: "eljthoijhlu6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.17,86a17.37,17.37,0,0,0-12.59-16.34L552.37,63c-10.08-1.38-17.18,10.86-18.13,21-1.06,11.25-1.85,23.12-.77,31.57,2.16,17,15,19.54,15,19.54s-.22,8-.36,13L552,170.22l30.6-26.12,5.67-57.9C588.24,85.91,588.18,86.38,588.17,86Z",
    style: {
      fill: "rgb(147, 103, 96)",
      transformOrigin: "560.612px 116.556px"
    },
    id: "elaarq90j16zi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.18,96.92a2.17,2.17,0,0,0,2,2.25,2.07,2.07,0,0,0,2.29-1.88,2.17,2.17,0,0,0-2-2.26A2.07,2.07,0,0,0,537.18,96.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "539.325px 97.1px"
    },
    id: "elvo2sig9ilbk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.59,90.7c.26.29,1.94-.88,4.27-.8s4,1.3,4.27,1c.13-.12-.13-.64-.86-1.21a6,6,0,0,0-3.4-1.16,5.75,5.75,0,0,0-3.42,1C536.72,90.06,536.46,90.57,536.59,90.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "540.86px 89.7373px"
    },
    id: "elix5hhuz5cl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.61,97a2.17,2.17,0,0,0,2,2.25,2.08,2.08,0,0,0,2.3-1.89,2.17,2.17,0,0,0-2-2.25A2.07,2.07,0,0,0,557.61,97Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "559.76px 97.1795px"
    },
    id: "elaj9c7jqwb2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.75,91.33c.26.29,1.94-.87,4.27-.8s4,1.3,4.27,1c.13-.12-.13-.64-.86-1.2a5.88,5.88,0,0,0-3.4-1.17,5.68,5.68,0,0,0-3.42,1C558.88,90.7,558.62,91.2,558.75,91.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "563.02px 90.3668px"
    },
    id: "el45d6p37eotk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.93,109.45a15.39,15.39,0,0,0-3.77-.8c-.59-.08-1.15-.22-1.24-.63a3,3,0,0,1,.45-1.75l1.9-4.48c2.65-6.39,4.58-11.64,4.33-11.75s-2.62,5-5.26,11.37l-1.83,4.51a3.42,3.42,0,0,0-.38,2.33,1.48,1.48,0,0,0,1,.9,3.73,3.73,0,0,0,1,.17A15.56,15.56,0,0,0,550.93,109.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "548.845px 99.7744px"
    },
    id: "el5mcuvndxxvo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.12,129.74s-5.83,11.45-22.7,9.35l.1-4A42.65,42.65,0,0,0,571.12,129.74Z",
    style: {
      fill: "rgb(111, 76, 71)",
      transformOrigin: "559.77px 134.544px"
    },
    id: "el0r3v9twmiou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.72,82.92c.21.64,2.55.41,5.28.83s4.92,1.22,5.3.67c.17-.27-.2-.88-1.07-1.52a9.29,9.29,0,0,0-8.06-1.14C560.15,82.13,559.63,82.62,559.72,82.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "565.025px 82.9576px"
    },
    id: "el7dzgtcshxkn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.55,83.58c.4.54,2,0,4,.08s3.55.46,4-.08c.17-.26-.07-.8-.77-1.33a5.74,5.74,0,0,0-6.37,0C537.62,82.78,537.38,83.32,537.55,83.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "541.55px 82.5749px"
    },
    id: "elg8xrgzvl3b7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.27,68.69a7.46,7.46,0,0,1,6.69-4,14.48,14.48,0,0,1,7.74,2.49c9.9,6.11,14.67,20.32,24.45,26.62,2.41,1.55,5.63.29,7.66,2.31s3.28,5.19,2.06,7.78a23.6,23.6,0,0,0,3.61-5.74,8,8,0,0,0-.09-6.6c-.82-1.51-2.3-2.7-2.67-4.38-.33-1.48.3-3,.28-4.52a10,10,0,0,0-1.43-4.35c-3.7-7-8.88-13.4-15.68-17.47a28.62,28.62,0,0,0-14.73-4.26,21.88,21.88,0,0,0-14.27,5.2c-2.29,2-4.69,4.09-3.62,6.94",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "565.578px 80.2299px"
    },
    id: "elx4q2z2ha7rg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.5,98.18c.19-.48,9.1-3.41,9,6-.14,9.12-9.28,7.06-9.29,6.8S585.5,98.18,585.5,98.18Z",
    style: {
      fill: "rgb(147, 103, 96)",
      transformOrigin: "589.855px 104.366px"
    },
    id: "elpgj7k3qh8y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588,107.54s.15.12.42.24a1.54,1.54,0,0,0,1.18,0c1-.33,1.81-1.85,1.89-3.49a5.24,5.24,0,0,0-.4-2.28,1.86,1.86,0,0,0-1.17-1.24.81.81,0,0,0-1,.42c-.12.25-.07.43-.12.45s-.19-.16-.11-.53a1,1,0,0,1,.37-.57,1.17,1.17,0,0,1,.88-.21,2.23,2.23,0,0,1,1.63,1.44,5.3,5.3,0,0,1,.5,2.55c-.09,1.84-1.06,3.54-2.39,3.89a1.67,1.67,0,0,1-1.44-.27C588.05,107.76,588,107.56,588,107.54Z",
    style: {
      fill: "rgb(111, 76, 71)",
      transformOrigin: "590.039px 104.292px"
    },
    id: "elir16oppkrlq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.26,93.6a4.08,4.08,0,0,1-.54-.32c-.34-.23-.87-.54-1.5-1a30.86,30.86,0,0,1-4.79-4.61,88.22,88.22,0,0,1-5.79-8,71.46,71.46,0,0,0-7.25-9.58,28.78,28.78,0,0,0-4.74-4,23.48,23.48,0,0,0-5.17-2.52,25.73,25.73,0,0,0-9.61-1.46,24.66,24.66,0,0,0-6.5,1.08,17.12,17.12,0,0,0-1.71.58,4.73,4.73,0,0,1-.6.19,3.75,3.75,0,0,1,.57-.27,15.46,15.46,0,0,1,1.69-.66,23.76,23.76,0,0,1,6.53-1.22,26,26,0,0,1,9.76,1.39,24,24,0,0,1,5.26,2.55,28.33,28.33,0,0,1,4.82,4A69.81,69.81,0,0,1,577,79.45a92.42,92.42,0,0,0,5.7,8,33.34,33.34,0,0,0,4.66,4.68c.61.49,1.12.82,1.44,1.07A3,3,0,0,1,589.26,93.6Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "565.16px 77.6892px"
    },
    id: "elaaiphs7m8b6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589,109.18a1.8,1.8,0,1,1-1.41,2.38,1.88,1.88,0,0,1,1-2.26",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "589.296px 110.957px"
    },
    id: "elzmixxymb48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.6,109.3a2.47,2.47,0,0,0-.86,1.2,1.52,1.52,0,0,0,.32,1.44,1.59,1.59,0,0,0,2.82-.81,1.59,1.59,0,0,0-.49-1.39,2.43,2.43,0,0,0-1.37-.56s.15-.09.43-.09a1.85,1.85,0,0,1,1.13.43,1.83,1.83,0,0,1,.68,1.67,2,2,0,0,1-1.41,1.69,2.06,2.06,0,0,1-2.09-.69,1.82,1.82,0,0,1-.3-1.77,1.87,1.87,0,0,1,.72-1C588.43,109.3,588.59,109.28,588.6,109.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "589.313px 111.016px"
    },
    id: "elw23x9g00y49",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.9,96.11c.07,2.49.11,5.12-1.11,7.3s-4.15,3.6-6.28,2.3c-1.73-1.06-2.2-3.33-2.44-5.35-.7-5.83-.92-11.7-1.67-17.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "581.164px 94.5235px"
    },
    id: "elx6usxzh684k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.64,64.42s.81-.13,2.27-.13a15.54,15.54,0,0,1,6,1.27,20.73,20.73,0,0,1,3.72,2,41.71,41.71,0,0,1,3.81,3.09,47.09,47.09,0,0,1,7.39,8.44c1.11,1.66,2.08,3.35,3.15,4.93a23.29,23.29,0,0,0,3.53,4.21,40.78,40.78,0,0,0,7.55,5.37c2.3,1.3,4.22,2.22,5.55,2.85l1.54.71a1.9,1.9,0,0,0,.55.21,2.87,2.87,0,0,0-.51-.3l-1.49-.8c-1.3-.68-3.2-1.65-5.46-3a42,42,0,0,1-7.4-5.4,22.81,22.81,0,0,1-3.44-4.15c-1-1.56-2-3.26-3.15-4.94a45.5,45.5,0,0,0-7.5-8.5,42.6,42.6,0,0,0-3.88-3.09,19.82,19.82,0,0,0-3.83-2,15,15,0,0,0-6.13-1.14,10.78,10.78,0,0,0-1.7.19A2.09,2.09,0,0,0,541.64,64.42Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "564.17px 80.7076px"
    },
    id: "elz4mtqs16ky7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.31,90.49a3.47,3.47,0,0,0,.79.57l2.27,1.42.76.47a2.48,2.48,0,0,0,1,.36,1,1,0,0,0,.62-.13.78.78,0,0,0,.35-.59,2,2,0,0,0-.39-1.17c-.79-1.33-1.65-2.8-2.56-4.36l-.37.33a9.61,9.61,0,0,0,6.14,2,2.73,2.73,0,0,0,.83-.12,1.14,1.14,0,0,0,.72-.6,1,1,0,0,0-.13-.92,3.77,3.77,0,0,0-.5-.59,18.78,18.78,0,0,1-3-4A31.07,31.07,0,0,1,592,78.93a4.46,4.46,0,0,0,.25,1.24,17.27,17.27,0,0,0,1.28,3.19,18.37,18.37,0,0,0,3,4.15c.33.33.66.71.52,1s-.64.41-1.12.4a9.1,9.1,0,0,1-3.07-.47A8.87,8.87,0,0,1,590.08,87L589,86.17l.69,1.15,2.61,4.33a1.74,1.74,0,0,1,.36.9c0,.26-.24.4-.53.37a4.71,4.71,0,0,1-1.62-.72l-2.34-1.29A5.67,5.67,0,0,0,587.31,90.49Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "592.419px 86.1233px"
    },
    id: "elpadafx4y8sa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.68,114a3.05,3.05,0,0,0-3.08-2.4,3.17,3.17,0,0,0-2.49,1.67,3.92,3.92,0,0,0-.23,3l0,.22a3.48,3.48,0,0,0,3.88,1A3.25,3.25,0,0,0,559.68,114Z",
    style: {
      fill: "rgb(111, 76, 71)",
      transformOrigin: "556.702px 114.656px"
    },
    id: "elv8e9h6u0xfn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.23,116.53c0-.35,2.36-.17,4.19-2s1.77-4.42,2.1-4.41c.15,0,.42.59.36,1.66a5.83,5.83,0,0,1-1.62,3.68,5.1,5.1,0,0,1-3.5,1.58C552.77,117,552.2,116.69,552.23,116.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "555.559px 113.58px"
    },
    id: "elywenfxy1dx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.08,142.08l-16.2-1.36S574,152.5,561.8,151.59s-13.48-9.07-13.48-9.07a56.84,56.84,0,0,0-27.14,15.55l-.27.34h0l-20.81,40.8,23.95,19.55,2.33-3.78L532,243.21l-7.34,10.12,9.1,9a66,66,0,0,0,46.27,19l38.43.06Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "559.28px 211.055px"
    },
    id: "el8gx7j8blk98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.52,142s7.21,0,11.46,2.36c11.56,6.53,27.13,43.75,27.13,43.75l-31,17.47S593,181.79,589.32,170.36c-.86-2.68,1.1-16.08,1.1-16S596.52,142.23,596.52,142Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "612.106px 173.79px"
    },
    id: "elukzgkazbtq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.61,174.68a3,3,0,0,1,.06.68c0,.5.05,1.15.08,1.95,0,1.7.16,4.15.32,7.18.32,6.06,1,14.41,2.29,23.57s3,17.38,4.38,23.29c.69,3,1.27,5.34,1.69,7l.47,1.9a3.18,3.18,0,0,1,.13.67,4,4,0,0,1-.23-.65l-.56-1.87c-.49-1.63-1.13-4-1.86-6.95a233.77,233.77,0,0,1-4.53-23.29,237.14,237.14,0,0,1-2.15-23.63c-.11-3-.16-5.5-.15-7.2,0-.8,0-1.45,0-1.95A3.22,3.22,0,0,1,522.61,174.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "527.289px 207.8px"
    },
    id: "elqauwiugyvwa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbstwmj5gkdc"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "577.814px 219.875px"
    },
    className: "animable",
    id: "elu8krsikyd7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610,237.05a34.22,34.22,0,0,0-7.42-6.18l-57.71-39.39-2.8,2.34c-.24,4.54,3.39,8.27,6.8,11.29a334.37,334.37,0,0,0,60.64,42.68,2.83,2.83,0,0,0,1.55.48c1-.1,2.22-1.79,2.4-2.8C614.06,242.29,612.09,239.56,610,237.05Z",
    id: "eltjwe6fca5j",
    className: "animable",
    style: {
      transformOrigin: "577.814px 219.875px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M635.11,188.07a5.61,5.61,0,0,1-.61.4l-1.78,1.06-6.6,3.81-21.93,12.42-.25.15-.11-.27-.17-.39-10.11-23.39c-1.25-3-2.28-5.38-3-7.12-.33-.8-.59-1.45-.79-1.94a5.33,5.33,0,0,1-.25-.69,3.37,3.37,0,0,1,.34.65c.23.48.52,1.11.89,1.9l3.16,7.05c2.64,6,6.25,14.25,10.25,23.34l.16.38-.36-.12,22-12.29,6.68-3.67,1.83-1A3.16,3.16,0,0,1,635.11,188.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "612.31px 189.01px"
    },
    id: "el0vkan6g2oqvo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.14,381.53s34.34-110.95,40.33-119.74,16.78-19.17,37.94-14.37,80.68,24.76,94.26,28,20.38,4.06,20.38,4.06,7.71,9.38,7.71,31c0,25.84-26.76,25.48-39.14,26.28s-49,1-49,1l-12.83,99.78s-12.54,4.79-20.93-3.59-5.19-17.58-17.57-18.78-29.95-2-34.75-23.16S423.14,381.53,423.14,381.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "523.45px 342.554px"
    },
    id: "elyg76ns6jl9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.43,288.53a1.21,1.21,0,0,1-.06.31c-.07.22-.15.52-.25.88-.23.81-.56,1.95-1,3.39-.88,3-2.15,7.22-3.71,12.45-3.14,10.53-7.48,25-12.26,41s-9,30.57-12,41.11c-1.49,5.25-2.69,9.51-3.54,12.49l-1,3.4c-.1.37-.19.66-.26.88a1.61,1.61,0,0,1-.1.3,1.43,1.43,0,0,1,.05-.31c.06-.23.13-.52.21-.89l.87-3.43c.75-3,1.92-7.25,3.37-12.54,2.93-10.57,7.13-25.12,11.9-41.16s9.18-30.53,12.41-41c1.63-5.21,2.95-9.44,3.87-12.4l1.08-3.36.3-.87A1.21,1.21,0,0,1,503.43,288.53Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "486.34px 346.635px"
    },
    id: "elxqs8bheyc3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.89,277.72a2.75,2.75,0,0,1-.49,0l-1.42.05c-1.23,0-3,.11-5.19.26a90.36,90.36,0,0,0-16.89,2.85,66.38,66.38,0,0,0-15.83,6.43l-1.35.79-1.17.76c-.73.48-1.36.89-1.84,1.27l-1.15.83a2.52,2.52,0,0,1-.42.26s.11-.13.35-.35l1.1-.9a22,22,0,0,1,1.8-1.35l1.15-.8,1.34-.82a61.53,61.53,0,0,1,15.89-6.62,81.83,81.83,0,0,1,17-2.72c2.2-.1,4-.14,5.22-.09l1.42,0A1.61,1.61,0,0,1,549.89,277.72Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "527.015px 284.384px"
    },
    id: "elgsnfu5mblp5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.14,422.73c-.15,0,.34-22.85,1.07-51s1.46-51,1.6-51-.34,22.86-1.07,51S504.28,422.74,504.14,422.73Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "505.474px 371.73px"
    },
    id: "elgdwxoh05gw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501,266.86s.22.21.54.65a17.83,17.83,0,0,1,1.19,1.94,24.38,24.38,0,0,1,2.45,7.12,24.1,24.1,0,0,1,.14,7.53,18.08,18.08,0,0,1-.45,2.24c-.15.52-.24.8-.28.79s.18-1.18.37-3.07a27.22,27.22,0,0,0-2.56-14.44C501.61,267.9,501,266.91,501,266.86Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.275px 276.995px"
    },
    id: "elye14uxewupr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.14,356.13a83,83,0,0,1-1.92-13.05,40.94,40.94,0,0,1,1.22,6.49A42.11,42.11,0,0,1,449.14,356.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "448.18px 349.605px"
    },
    id: "el5cu37bjgf3u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.53,376.31a8.09,8.09,0,0,1-1.83,1.06c-1.16.59-2.78,1.38-4.58,2.22s-3.44,1.57-4.64,2.08a9,9,0,0,1-2,.73,8.09,8.09,0,0,1,1.83-1.06c1.16-.6,2.77-1.38,4.57-2.22s3.44-1.58,4.64-2.08A8.8,8.8,0,0,1,472.53,376.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "466.005px 379.355px"
    },
    id: "elfqhz7sb8csw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.33,346.51a37.27,37.27,0,0,1-2.6-8.44,19.46,19.46,0,0,1,1.55,4.15A18.63,18.63,0,0,1,474.33,346.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "473.03px 342.29px"
    },
    id: "eli378u4av7bc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.11,309a17.17,17.17,0,0,1-5.16,1.87,17.55,17.55,0,0,1-5.45.68c0-.15,2.41-.48,5.33-1.18S463.06,308.89,463.11,309Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "457.805px 310.275px"
    },
    id: "eltsj902cn06h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.38,311.49a26,26,0,0,1-1.66-4.82,26.62,26.62,0,0,1-1.16-5,24.3,24.3,0,0,1,1.66,4.83A24.83,24.83,0,0,1,489.38,311.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "487.97px 306.58px"
    },
    id: "el9fxlaw90hc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.84,283a25.33,25.33,0,0,1,.2-7.24,25.33,25.33,0,0,1-.2,7.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "475.94px 279.38px"
    },
    id: "elnzulrcrmlu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,257.67a20.5,20.5,0,0,1-4.5.67,19.93,19.93,0,0,1-4.54.15,20.5,20.5,0,0,1,4.5-.67A19.93,19.93,0,0,1,483,257.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "478.48px 258.08px"
    },
    id: "eler2hkvjh5d5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.12,269.94a25.88,25.88,0,0,1-1.34-7.25,13.4,13.4,0,0,1,.93,3.58A13.68,13.68,0,0,1,515.12,269.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "514.452px 266.315px"
    },
    id: "el0ka0lgn3y3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.58,266a31.8,31.8,0,0,1-7.09,3.71,30.2,30.2,0,0,1,7.09-3.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "542.035px 267.855px"
    },
    id: "elgz014snh0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.51,304.27a47,47,0,0,1-5.75-4.16,50.31,50.31,0,0,1-5.44-4.57,47.46,47.46,0,0,1,5.76,4.16A50.75,50.75,0,0,1,526.51,304.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "520.915px 299.905px"
    },
    id: "elr2vm5jr7psg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.25,291.73a27.46,27.46,0,0,1-4,3.39,26.76,26.76,0,0,1-4.3,3,50.55,50.55,0,0,1,8.29-6.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "548.1px 294.925px"
    },
    id: "elimo0s3l0iyk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.93,289.65a66.72,66.72,0,0,1-6.8-9.47,65.23,65.23,0,0,1,6.8,9.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "588.53px 284.915px"
    },
    id: "ele2bgix4davg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.72,307.58a11.77,11.77,0,0,1-1.82,1.72c-1.18,1-2.83,2.35-4.7,3.78s-3.6,2.69-4.88,3.56a11.16,11.16,0,0,1-2.13,1.31,13.15,13.15,0,0,1,1.91-1.61l4.78-3.67,4.78-3.66A12.29,12.29,0,0,1,611.72,307.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "604.955px 312.765px"
    },
    id: "el8fhme2ebm9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.31,323.39a40.21,40.21,0,0,1,.53-6.57,41.77,41.77,0,0,1,1-6.5,40.06,40.06,0,0,1-.53,6.56A42.33,42.33,0,0,1,572.31,323.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "573.075px 316.855px"
    },
    id: "el52zxzo1g7cu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.56,331.22a8,8,0,0,1-2.06-.81,47.63,47.63,0,0,1-4.66-2.59,46.18,46.18,0,0,1-4.34-3.1,8.61,8.61,0,0,1-1.62-1.51c.1-.12,2.74,2,6.24,4.17S550.63,331.08,550.56,331.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "544.221px 327.213px"
    },
    id: "el5thfg9cxqtq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.09,339.14c-.11-.1,1.83-2.21,3.94-5s3.62-5.23,3.75-5.15a23.29,23.29,0,0,1-3.33,5.46A23,23,0,0,1,517.09,339.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "520.933px 334.064px"
    },
    id: "elkks1jict63",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.87,376.6a41.69,41.69,0,0,1-4-5.18,40.56,40.56,0,0,1-3.6-5.48,42.64,42.64,0,0,1,4,5.18A40.56,40.56,0,0,1,520.87,376.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "517.07px 371.27px"
    },
    id: "elscyg1u8zui",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.48,358.58a52.68,52.68,0,0,1-6.41-8.46,28.43,28.43,0,0,1,3.41,4.07A27.76,27.76,0,0,1,498.48,358.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "495.275px 354.35px"
    },
    id: "el6v1edy72gy6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.55,381.14a31.52,31.52,0,0,1-5.14,2.32,31.06,31.06,0,0,1-5.34,1.84,31.52,31.52,0,0,1,5.14-2.32A31.06,31.06,0,0,1,498.55,381.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "493.31px 383.22px"
    },
    id: "elirtecv2wta7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.34,408.36a30.73,30.73,0,0,1-3-4.66,29.92,29.92,0,0,1-2.54-4.93,59.65,59.65,0,0,1,5.53,9.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "490.57px 403.565px"
    },
    id: "el9uzwasikgag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.93,421.76a56.28,56.28,0,0,1-7,8.06,27.12,27.12,0,0,1,3.32-4.2A26.65,26.65,0,0,1,517.93,421.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "514.43px 425.79px"
    },
    id: "elndtu054g7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.64,203.53l7,16.1-33.26-17.52L571,216.59S608.89,246,622.7,249.22c11.59,2.67,20.25-4.63,20.86-14.88.54-9-12.67-43.9-12.67-43.9Z",
    style: {
      fill: "rgb(147, 103, 96)",
      transformOrigin: "607.288px 220.107px"
    },
    id: "el0etx20qa694",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.69,226.08c-.1.12-2.54-1.83-5.83-3.81s-6.15-3.24-6.08-3.39a7.2,7.2,0,0,1,1.94.67,35.46,35.46,0,0,1,4.41,2.27,37,37,0,0,1,4.07,2.85A6.81,6.81,0,0,1,625.69,226.08Z",
    style: {
      fill: "rgb(111, 76, 71)",
      transformOrigin: "619.734px 222.483px"
    },
    id: "eleoy4jdmhoqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.51,200.83a16.52,16.52,0,0,0-.72-7.11c-1.26-4-6-9.34-5.44-12s-2.68-2.32-3.85.77c-.75,2,.06,8.82.06,8.82s-4.92-1.53-6.77-4.91-10-12.39-11.92-11.65c-2.16.84.12,3,.86,4.27.55,1,5.17,8.33,5.17,8.33S545,178.83,543,178.45c-2.22-.42-1.34,2.3-.53,2.84.51.34-2.07.69-1.38,3.15.47,1.68,5.15,6.15,6.62,7.08l3,1.91-9.89-4.69s-2.51.49-.74,2.62c.79.95,26.5,22.2,28.61,23.67,3.65,2.52,9,5.93,9,5.93l9.65-15.63Z",
    style: {
      fill: "rgb(147, 103, 96)",
      transformOrigin: "563.394px 197.833px"
    },
    id: "eludk88a37snk",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2",
    className: "animable",
    style: {
      transformOrigin: "196.77px 298.095px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.62,240a6.27,6.27,0,0,0-3.26-10.35h0l11.3-7.6h0l-8.44-12.54h0a6.28,6.28,0,1,1-3.08-4.59h0l-9.46-14h0l-31.18,21h0l21,31.18h0l12.28-8.26h0A6.28,6.28,0,0,0,272.62,240Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "254.58px 217.01px"
    },
    id: "elblyfiku8vlu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.62,240a5.23,5.23,0,0,1-.78.75,6.11,6.11,0,0,1-2.85,1.29,6.33,6.33,0,0,1-4.87-1.15,6.33,6.33,0,0,1-2.5-6.14l.22.14-12.25,8.3-.27-.06L228.3,212l.07-.35,25.55-17.2c1.89-1.27,3.76-2.54,5.62-3.78l.36.07,9.45,14.05-.34.36a6,6,0,0,0-9,5.54,5.94,5.94,0,0,0,1.55,3.73,6,6,0,0,0,9.88-1.3,6.16,6.16,0,0,0,.6-3.57l.39-.15c3.06,4.58,5.88,8.79,8.41,12.56l-.05.25-11.33,7.56,0-.23a6.36,6.36,0,0,1,4.32,3.47,6.25,6.25,0,0,1-.53,6.36,3.84,3.84,0,0,1-.56.64s.19-.22.5-.68a6.36,6.36,0,0,0,.95-2.29,6.2,6.2,0,0,0-4.74-7.25l0-.23,11.27-7.64-.05.24-8.46-12.52.38-.15a6.56,6.56,0,0,1-.63,3.83,6.42,6.42,0,0,1-2.82,2.85,6.52,6.52,0,0,1-4.09.63,6.31,6.31,0,0,1-3.71-2.06A6.52,6.52,0,0,1,264.65,204a6.58,6.58,0,0,1,4.61.73l-.33.36-9.46-14,.36.07-5.62,3.78-25.57,17.18.07-.34L249.64,243l-.26,0,12.3-8.22.22.14a6.2,6.2,0,0,0,9.89,5.9C272.35,240.3,272.6,240,272.62,240Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "254.57px 216.93px"
    },
    id: "elagb4m1n9iqu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.67,153.82a34.57,34.57,0,0,0-13.1-21.73l.71-.4c-6.61-3-15.32.3-18.33,6.89-1.24,2.7-1.58,5.71-2.3,8.59s-2,5.84-4.43,7.51c-1.31.9-2.87,1.35-4.22,2.17s-2.59,2.19-2.49,3.77c.12,2,2.27,3.3,4.25,3.72s4.15.42,5.85,1.51a6.35,6.35,0,1,0,7.3,10.38c-1.47,3.24.18,7.36,3.2,9.24a11,11,0,0,0,10.25.24,19.9,19.9,0,0,0,7.8-7.11A34.54,34.54,0,0,0,183.67,153.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "161.801px 158.717px"
    },
    id: "el9olcmbvbz96",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.43,139.78c-.2-2.44-2.32-4.37-4.65-5.13a18.87,18.87,0,0,0-7.27-.41c1.09-3.07,2.21-6.25,2-9.5s-2-6.65-5.12-7.65c-2.67-.86-5.59.2-8,1.64s-4.65,3.26-7.32,4.13c-6.94,2.27-14.31-2.53-21.59-2-7.48.56-14.66,8.18-14.5,15.68,11.39,6,22.9,12.06,32.69,20.42,5.3,4.52,10.91,10,17.87,9.76a12.08,12.08,0,0,0,9.4-19.06C227.12,145.94,230.74,143.38,230.43,139.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "197.213px 141.754px"
    },
    id: "elbek6ehsghlh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.53,155c.43-9.72-8.93-20.49-18.67-20.51L166,137l-.45,5.21-5,64.54h0s.44,21,18.07,21.75c15.85.63,16.78-16.08,16.78-16.08l.83-12.19s12.76.86,17.06-15C215.41,177.42,216,165.77,216.53,155Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "188.547px 181.504px"
    },
    id: "elwo394f57rxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.78,168.85a2.07,2.07,0,0,1-2.21,1.87,2,2,0,0,1-1.93-2.09,2.08,2.08,0,0,1,2.21-1.87A2,2,0,0,1,210.78,168.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.71px 168.74px"
    },
    id: "elbylce77rfhb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.76,163.22c-.28.24-1.72-1.08-3.94-1.32s-4,.7-4.19.41.21-.59,1-1a5.64,5.64,0,0,1,3.38-.66A5.5,5.5,0,0,1,212.1,162C212.72,162.6,212.9,163.12,212.76,163.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.694px 161.93px"
    },
    id: "elkyzjf1jvc1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,166.87a2.07,2.07,0,0,1-2.21,1.87,2,2,0,0,1-1.93-2.09,2.08,2.08,0,0,1,2.22-1.87A2,2,0,0,1,192,166.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "189.93px 166.76px"
    },
    id: "elzz1i8z6pud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.28,161.36c-.28.24-1.72-1.08-3.94-1.32s-4,.7-4.19.41c-.1-.14.21-.59,1-1a5.64,5.64,0,0,1,3.38-.66,5.5,5.5,0,0,1,3.11,1.39C192.24,160.74,192.42,161.26,192.28,161.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "188.228px 160.07px"
    },
    id: "elcsrnr99h6w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.22,178.22a17.38,17.38,0,0,1,3.68-.19c.57,0,1.12,0,1.25-.35s0-.87-.21-1.46c-.4-1.22-.82-2.49-1.25-3.83s-2.71-9.22-2.66-9.94c.25-.06,1.86,4.31,3.59,9.75.41,1.34.81,2.62,1.18,3.85a2.41,2.41,0,0,1,.08,1.91,1.46,1.46,0,0,1-1,.61,4.62,4.62,0,0,1-1,0A16.91,16.91,0,0,1,197.22,178.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "200.13px 170.523px"
    },
    id: "elgaksl2ej2ac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.31,200.36a41.2,41.2,0,0,1-20.94-8.08s4.3,11.83,20.57,12.07Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "185.84px 198.315px"
    },
    id: "eltbhaf3yjk3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.54,177.7c.36,0,.11,2.43,2,4.36S197,184,197,184.35c0,.15-.62.41-1.71.32a6,6,0,0,1-3.73-1.77,5.3,5.3,0,0,1-1.52-3.65C190,178.24,190.38,177.67,190.54,177.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "193.519px 181.194px"
    },
    id: "ele711c9zpfcg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.35,153.87c-.33.66-2.19-.06-4.52-.15s-4.33.36-4.5-.32c-.08-.33.37-.92,1.25-1.45a6.44,6.44,0,0,1,3.55-.86,5.84,5.84,0,0,1,3.32,1.22C192.19,152.93,192.49,153.56,192.35,153.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "187.852px 152.614px"
    },
    id: "ely7apa0knfrd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.66,155.6c-.43.58-2-.1-4-.19s-3.6.28-4-.36c-.15-.31.13-.91.87-1.45a5,5,0,0,1,3.26-.87A5.06,5.06,0,0,1,213,154C213.65,154.68,213.85,155.31,213.66,155.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.675px 154.272px"
    },
    id: "eldpatnwzmjn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.12,145.69c-2.3-5.82-7.41-10.26-13.21-12.62s-12.24-2.77-18.47-2.15a115.83,115.83,0,0,0-18.35,3.86c-1.46.39-3.07.88-3.88,2.16a6.13,6.13,0,0,0-.69,3q-.78,13-1.57,26l1.71,5.56c2.79.35,5.39-1.42,7.45-3.32a38.71,38.71,0,0,0,12.26-25.95,12.84,12.84,0,0,1,1.1,3.91,4.29,4.29,0,0,0,2.21,3.25c2.11.84,4.23-1.42,4.83-3.62s.5-4.67,1.82-6.52A26,26,0,0,0,199,148c1.5,1.09,3.54,2,5.11,1a3.5,3.5,0,0,0,1.36-3.44A10.32,10.32,0,0,0,204,142a20.41,20.41,0,0,0,9.25,7.1,2.86,2.86,0,0,0,2.5.07C216.81,148.46,216.59,146.86,216.12,145.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "188.23px 151.103px"
    },
    id: "elfy40rtn3ieb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,160.72c-.23-.13-9.59-3.92-10.27,5.94s9.37,8.52,9.41,8.24S167,160.72,167,160.72Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "161.848px 167.508px"
    },
    id: "el4p06of19la8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33,171s-.18.11-.48.22a1.69,1.69,0,0,1-1.28-.06c-1-.45-1.78-2.17-1.71-4a5.72,5.72,0,0,1,.65-2.43,2,2,0,0,1,1.38-1.23.88.88,0,0,1,1,.54c.11.28,0,.48.08.5s.23-.15.18-.57a1.11,1.11,0,0,0-.35-.64,1.3,1.3,0,0,0-.93-.32,2.42,2.42,0,0,0-1.9,1.41,5.78,5.78,0,0,0-.79,2.71c-.07,2,.82,3.92,2.22,4.43a1.85,1.85,0,0,0,1.59-.15C163.3,171.19,163.37,171,163.33,171Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "161.258px 167.341px"
    },
    id: "eleiofno54m9v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.47,140.77a2.25,2.25,0,0,1-.26.56c-.19.35-.48.87-.89,1.51a31.78,31.78,0,0,1-4,5.07,33.25,33.25,0,0,1-3.32,3c-.65.49-1.3,1-2,1.46a4.67,4.67,0,0,1-2.58.88,3,3,0,0,1-2.45-1.5,5.4,5.4,0,0,1-.73-2.9c.1-2.08,1.19-3.89,1.6-5.87a7.56,7.56,0,0,0,.13-.76l.44.21-4.45,3.94-2.11,1.87a5.55,5.55,0,0,1-2.4,1.41,2,2,0,0,1-1.42-.26,2.3,2.3,0,0,1-.85-1.09,5.92,5.92,0,0,1-.34-2.46,17.56,17.56,0,0,1,3.42-10,15,15,0,0,1,1.1-1.3,2.94,2.94,0,0,1,.43-.41s-.53.63-1.37,1.83a17.82,17.82,0,0,0-2.57,5.61,17.15,17.15,0,0,0-.58,4.23,5.52,5.52,0,0,0,.32,2.28,1.57,1.57,0,0,0,1.77,1,5,5,0,0,0,2.17-1.32l2.1-1.87c1.43-1.27,2.9-2.59,4.42-3.93l.52-.46-.08.67c0,.26-.08.54-.14.82-.45,2.08-1.52,3.89-1.6,5.78a5,5,0,0,0,.64,2.62,2.48,2.48,0,0,0,2,1.28,4.27,4.27,0,0,0,2.32-.78c.71-.45,1.38-.95,2-1.42a35.73,35.73,0,0,0,3.33-2.91,35.19,35.19,0,0,0,4.11-4.92c.43-.62.75-1.12,1-1.45A5.08,5.08,0,0,1,179.47,140.77Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "166.647px 143.69px"
    },
    id: "el7kp4p86aro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,320.42s3.31,14.88,8.63,16.35c3.36.93,50.87,7.25,50.87,7.25l12.93,10.73,43.5-24.7L229.49,312.1,206.8,298.91l-39.22,1.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "200.765px 326.83px"
    },
    id: "elcqfei4o5nxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.18,206.84c-7.7,2.72-23.5-2.44-35.52-8.55-.71.24-20.16,5.63-23.69,31.07s.6,86.47.6,86.47l1.84,8.28s29.31-16.66,41.32-19.25,25.07-5.95,25.07-5.95Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "171.671px 261.2px"
    },
    id: "el8lsehp7pzst",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhxyempdvb7f"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "175.325px 261.643px"
    },
    className: "animable",
    id: "elhvqa9chkcx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.34,242s5.13,26.09,12.95,32.84,15.36,7.39,21.48,5.57S203.31,269,203.31,269l-.51-6.26s-35.17-9-35.22-9.29S147.34,242,147.34,242Z",
    id: "el083g33t5i3rg",
    className: "animable",
    style: {
      transformOrigin: "175.325px 261.643px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M164.62,263.06s4.94,13.67,17.92,10.63,53.74-25.55,53.74-25.55l-8.11-14-40.6,12.57Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "200.45px 254.136px"
    },
    id: "eld4hjh4f5ai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.81,236.07l8.12-9.93s12.77-8.11,15.41-7.91,6.08.81,4.66,4.66c0,0,4.06,2,3.25,4.26S250.6,230,250.6,230s4.47.61,3.75,3.45-2.33,2.63-2.33,2.63,1.21,1.63.2,2.44a35.4,35.4,0,0,1-5.07,2.43s-4.89,4.87-8.53,6.69a29.16,29.16,0,0,1-7.69,2.44Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "238.619px 234.153px"
    },
    id: "elh0fgu0zyagn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.78,209.88a14.94,14.94,0,0,0-20.47,2.76,31.57,31.57,0,0,0-3.94,6.22c-2.8,5.95-4.3,19.49-4.3,19.49l16.45,27.09,31.65-22.53L179.24,214.3S176.89,212.15,173.78,209.88Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "169.12px 236.229px"
    },
    id: "elj3780ze3yg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,207a2.29,2.29,0,0,1,.41-.14l1.22-.36c.28-.07.57-.18.91-.24l1.12-.16A12.44,12.44,0,0,1,159,206l1.5,0a17.9,17.9,0,0,1,7.4,1.87,21,21,0,0,1,4,2.57,22.91,22.91,0,0,1,3.75,3.8h0l17.47,28.58.12.2-.19.14-5.22,3.71L161.4,265.62l-.2.14-.12-.2c-4.89-8.13-9-14.91-11.85-19.69-1.41-2.36-2.51-4.23-3.29-5.53l-.85-1.47a2.94,2.94,0,0,1-.27-.52,5.25,5.25,0,0,1,.33.48c.22.35.52.83.91,1.43l3.39,5.47,12,19.59-.32-.06,26.41-18.85,5.22-3.71-.08.35c-6.54-10.8-12.52-20.66-17.36-28.64h0a22.55,22.55,0,0,0-7.57-6.31,18,18,0,0,0-7.27-1.93H159a10,10,0,0,0-1.3.13l-1.11.13c-.34,0-.64.15-.91.21l-1.23.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.03px 235.88px"
    },
    id: "elg354gix9isn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.27,333.15s7.22,12.17,3.63,20.69-51.8,54-51.8,54L188.45,394.2l32.35-42.83Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "223.176px 370.495px"
    },
    id: "el9nb0elba08i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.25,405.7l-1,1.08s11.43,24.09,8.44,27.72L178.78,401l11.65-11.5C193.46,396.93,198.79,402.43,207.25,405.7Z",
    style: {
      fill: "#96BBCE",
      transformOrigin: "196.984px 412px"
    },
    id: "el2n4uaemmb0o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.78,401l2.8-2.77L215,431.36s.95,2.18-.28,3.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "197.065px 416.365px"
    },
    id: "elu1fn2e3n84p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,410.82s.11-.37.54-.79a4.87,4.87,0,0,1,2-1.12,5,5,0,0,1,2.31-.08c.58.14.89.34.87.4a11.89,11.89,0,0,0-3,.19A11.67,11.67,0,0,0,202,410.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "204.86px 409.776px"
    },
    id: "elc0r2vp0cwf6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.47,408.65a5.29,5.29,0,0,1,5.86-1.61,25.42,25.42,0,0,0-3.05.39A26.21,26.21,0,0,0,200.47,408.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "203.4px 407.69px"
    },
    id: "ell1mfnm3g73",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,414.27c-.13,0,.38-1.24,1.69-2.06a3.32,3.32,0,0,1,2.59-.64c0,.16-1.14.33-2.31,1.09S204.09,414.36,204,414.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "206.13px 412.899px"
    },
    id: "elqtdlma3ipse",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.46,409.64a2.92,2.92,0,0,1,.54-1.75,9.24,9.24,0,0,1,1.17-1.61c.25-.28.51-.56.79-.85a3.67,3.67,0,0,1,.49-.44.94.94,0,0,1,.83-.14.73.73,0,0,1,.47.76,1.51,1.51,0,0,1-.21.69,5.5,5.5,0,0,1-.66,1,6.18,6.18,0,0,1-1.52,1.32,3.12,3.12,0,0,1-1.73.59c0-.08.64-.28,1.52-.9A6.59,6.59,0,0,0,210.5,407a7,7,0,0,0,.59-.93c.17-.32.19-.69,0-.71s-.5.15-.78.45l-.8.81a12.37,12.37,0,0,0-1.21,1.47C207.7,409,207.55,409.66,207.46,409.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.607px 407.225px"
    },
    id: "el6g9l45x2vp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.81,409.76s-.11,0-.31-.05l-.15,0,.15-.1a5.93,5.93,0,0,1,1.92-.76,7.23,7.23,0,0,1,1.62-.18,7.13,7.13,0,0,1,.91.05,1.49,1.49,0,0,1,.54.14.81.81,0,0,1,.43.53.71.71,0,0,1-.42.76,2.3,2.3,0,0,1-.61.18,7.37,7.37,0,0,1-1.11.12,6.51,6.51,0,0,1-1.87-.23,3.1,3.1,0,0,1-1.53-.77c0-.08.62.21,1.62.4a6.49,6.49,0,0,0,1.76.11,6.24,6.24,0,0,0,1-.14c.38,0,.69-.22.62-.32,0-.3-.87-.3-1.37-.33a7.42,7.42,0,0,0-1.53.1,12.14,12.14,0,0,0-1.93.49v-.15C207.74,409.67,207.82,409.74,207.81,409.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "210.139px 409.561px"
    },
    id: "elkyxt4covosg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxlg3cm138k"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.34,
    y: 408.22,
    width: 131.79,
    height: 10.58,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "211.235px 413.51px",
      transform: "rotate(-90deg)"
    },
    className: "animable",
    id: "elgz8jfbr9a14"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 120.61,
    y: 408.61,
    width: 89.81,
    height: 8.75,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "165.515px 412.985px"
    },
    id: "elvdgmw8rmoeb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.99,
    y: 209.01,
    width: 11.3,
    height: 270.4,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "118.64px 344.21px"
    },
    id: "el1z3z5j028dt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.99,
    y: 338.01,
    width: 108.92,
    height: 19.03,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "167.45px 347.525px"
    },
    id: "elgs7k20idw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.91,357c0,.14-24.32.26-54.31.26s-54.31-.12-54.31-.26,24.31-.26,54.31-.26S221.91,356.9,221.91,357Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.6px 357px"
    },
    id: "elf3j9wy77b8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.1,338c0,.14-12,.26-26.7.26s-26.7-.12-26.7-.26,12-.26,26.7-.26S166.1,337.87,166.1,338Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "139.4px 338px"
    },
    id: "elun55umfb80h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.29,360.2c.15,0,.26,24.22.26,54.08s-.11,54.08-.26,54.08-.26-24.21-.26-54.08S124.15,360.2,124.29,360.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "124.29px 414.28px"
    },
    id: "eljlyere1b1r",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTherapyDis);
export default __webpack_public_path__ + "static/media/TherapyDis.8f3a5f1a8e139deac9b78718b79c9d0c.svg";
export { ForwardRef as ReactComponent };